import React from "react";
import { Link, Prompt } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as specialistActions from "../../actions/specialistActions";
import * as documentUploadActions from "../../actions/documentUploadActions";
import * as SVGICONS from "../../images/img/images";
import validator from "./../common/validator.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as constant from "../../constants/constant";
import Availability from "./specialistAvailabilityV2";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
// import { browserHistory } from 'react-router';
import Modal from "react-modal";
import _ from "underscore";
// import { WithContext as ReactTags } from 'react-tag-input';
// import Geocode from "react-geocode";
import ClinicDetail from "./viewClinicDetail";
import moment from "moment-timezone";
import TimezonePicker from "react-timezone";
// import autocomplete from 'react-google-autocomplete';
import * as dashboardActions from "../../actions/dashboardActions";
import * as userActions from "../../actions/usersActions";
import $ from "jquery";
// import Textarea from 'react-textarea-count'
import Textarea from "react-textarea-autosize";
import { Multiselect } from "multiselect-react-dropdown";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import SpecialistLanguage from "./SpecialistLanguage";
import Select from "react-select";
import { languageOptions } from "./data";
// import Popover from '@material-ui/core/Popover';
import CustomTextField from './../miniComponents/CustomTextField'
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@material-ui/icons/Clear";
import ErrorIcon from "@material-ui/icons/Error";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { fade,
  ThemeProvider,
  withStyles,
  makeStyles,
  createMuiTheme, } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Form, Button, Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { MultipleSelect } from "react-select-material-ui";
import FormHelperText from "@material-ui/core/FormHelperText";
import Avatar from "@material-ui/core/Avatar";
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
// import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { CardHeader } from "@material-ui/core";
// import Select from '@material-ui/core/Select';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Input from "@material-ui/core/Input";
// import Select from '@material-ui/core/Select';
import "./../../styles/css/specialistProfileNew.css";
import { light } from "@material-ui/core/styles/createPalette";
import { Popover } from "antd";

const genderList = [
  {
    value: "Male",
    label: "Male",
  },
  {
    value: "Female",
    label: "Female",
  },
];

const errorFontSize = {
  fontSize: 11,
};

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const theme = createMuiTheme({
  palette: {
    primary: {
        main: "#00c8fc"
    },
  },
});



let finalConditionalProcedureMappingList = [];

const delimiters = [KeyCodes.comma, KeyCodes.enter];
var suggestions;
class SpecialistProfile extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      prompt: true,
      isDirty: false,
      firstRun: true,
      
      conditionProcedure: [],
      conditionProcedureMsg: "",
      noConditionProcedure: false,

      Awards: [{ value: "", message: "", isValid: true }],
      selectedLanguagesValues: [],
      conditionProcedureSelectedVal: [],
      viewProPicUploadDialog: false,
      uploadedSpecialistImageObj: {},
      specialistInfo: {},
      clinicConflict: [],
      modalIsOpen: false,
      userName: { value: "", isValid: true, message: "" },
      phoneNo: { value: "", isValid: true, message: "" },
      gender: { value: "Male", isValid: true, message: "" },
      email: { value: "", isValid: true, message: "" },
      image: { value: "", isValid: true, message: "" },
      userId: "",
      addressChange: false,
      yearExperience: { value: "", isValid: true, message: "" },
      specializationList: [],
      conditionalProcedureMappingList: [],
      EduSummary: [
        {
          academics: "",
          qualifications: "",
          academicsMessage: "",
          qualificationsMessage: "",
          isValidAcademics: true,
          isValidQualifications: true,
        },
      ],
      subSpecializationList: [{ id: "", text: "" }],
      specialization: { value: "", isValid: true, message: "" },
      registrationNo: { value: "", isValid: true, message: "" },
      phoneNoCountryCode: {
        value: localStorage.getItem("calling_code"),
        isValid: true,
        message: "",
      },
      qualification: { value: "", isValid: true, message: "" },
      monthExperience: { value: "", isValid: true, message: "" },
      consultationErrMsg: "",
      subSpecialization: { value: "", isValid: true, message: "" },
      profileSummary: { value: "", isValid: true, message: "" },
      academics: { value: "", isValid: true, message: "" },
      professionalAward: { value: "", isValid: true, message: "" },
      isNotReset: true,
      isOnloadSpecialization: true,
      clinicInfoErr: "",
      clinicInfoFlag: true,
      experienceList: [],

      //for instead reflect image change
      defaultImageURL: null,
      imageCopy: "",
      removeProfileImageDialog: false,
      file: "",
      imagePreviewUrl: "",
      totalErrors: false,
      imageToBeDeleted: false,

      //Availability
      clinicName: { value: "", isValid: true, message: "" },
      addressLineOne: { value: "", isValid: true, message: "" },
      sunday: { value: false, isValid: true, message: "" },
      monday: { value: false, isValid: true, message: "" },
      tuesday: { value: false, isValid: true, message: "" },
      wednesday: { value: false, isValid: true, message: "" },
      thursday: { value: false, isValid: true, message: "" },
      friday: { value: false, isValid: true, message: "" },
      saturday: { value: false, isValid: true, message: "" },
      timezoner: { value: "Select TimeZone", isValid: true, message: "" },
      Address: { value: "", isValid: true, message: "" },
      countryList: [],
      country: { value: "", isValid: true, message: "" },
      stateList: [],
      stateName: { value: "", id: "", isValid: true, message: "" },
      phoneCode1: { value: "", isValid: true, message: "" },
      phoneCodeList: constant.PHONENOCOUNTRYCODE,
      phoneCode2: { value: "", isValid: true, message: "" },
      currencyList: constant.CURRENCY,
      currencySymbol: { value: "", isValid: true, message: "" },
      fee: { value: "", isValid: true, message: "" },
      city: { value: "", isValid: true, message: "" },
      zipCode: { value: "", isValid: true, message: "" },
      mobileNo: { value: "", isValid: true, message: "" },
      telephoneNo: { value: "", isValid: true, message: "" },
      clinicInfo: [],
      isValidZipcode: false,
      isFromEdit: false,
      editIndex: -1,
      availId: "",
      latitude: 0.0,
      longitude: 0.0,
      availabilitySlot: {},
      isPrimary: { value: "true" },
      isDisable: true,

      editEnabled: false,
      isDisablePI: true,
      isDisablePB: true,
      isDisableES: true,
      isDisablePS: true,
      isDisableAM: true,
      isDisabled: { state: true, city: true, country: true },

      //Check zipcode
      zipcodeMatch: true,
      stateErrorCode: 200,
      successMsg: "",
      logoutButton: false,
      editButton: true,
      languageFetched: true,
      // disabled: true,

      //Clinic Banner Temp and final Banner obj
      tempBannerImage: null,
      tempUpClinicBanner: null,
      clinicBannerObj: null,
      //

      clinicBannerImageDeleted: false,
      clinicBannerImage: "noUserImage.jpg",

      saturdayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      saturdayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      saturdayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      saturdayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      sundayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      sundayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      sundayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      sundayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      mondayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      mondayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      mondayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      mondayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      tuesdayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      tuesdayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      tuesdayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      tuesdayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      wednesdayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      wednesdayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      wednesdayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      wednesdayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      thursdayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      thursdayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      thursdayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      thursdayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      fridayMornSTValid: {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      },
      fridayMornETValid: {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      },
      fridayEvenSTValid: {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      },
      fridayEvenETValid: {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      },

      //view clinic Info
      viewClinicModal: false,
      viewClinicData: {},

      sundayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      sundayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      saturdayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      saturdayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      mondayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      mondayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      tuesdayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      tuesdayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      wednesdayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      wednesdayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      thursdayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      thursdayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      fridayMorningSchedule: {
        inTime: "00:00",
        outTime: "10:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },
      fridayEveningSchedule: {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      },

      showNotificationDiv: false,

      sundayMorning: { value: false, isValid: true, message: "" },
      sundayEvening: { value: false, isValid: true, message: "" },

      mondayMorning: { value: false, isValid: true, message: "" },
      mondayEvening: { value: false, isValid: true, message: "" },

      tuesdayMorning: { value: false, isValid: true, message: "" },
      tuesdayEvening: { value: false, isValid: true, message: "" },

      wednesdayMorning: { value: false, isValid: true, message: "" },
      wednesdayEvening: { value: false, isValid: true, message: "" },

      thursdayMorning: { value: false, isValid: true, message: "" },
      thursdayEvening: { value: false, isValid: true, message: "" },

      fridayMorning: { value: false, isValid: true, message: "" },
      fridayEvening: { value: false, isValid: true, message: "" },

      saturdayMorning: { value: false, isValid: true, message: "" },
      saturdayEvening: { value: false, isValid: true, message: "" },
      options: constant.SPECIALIST_PROFILE_LANGUAGE,
      languages: [],
      languageError: { error: false, message: "" },


      deleteClinicDialog: false,
      chooseAnotherClinicDialog: false,
      clinicToBeDeletedId: null

    };
    this.uploadSpecialistImage = this.uploadSpecialistImage.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.saveSpecialistProfile = this.saveSpecialistProfile.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
    //Availability
    this.submitAvailability = this.submitAvailability.bind(this);
    this.changeInAvailability = this.changeInAvailability.bind(this);
    // this.onCountryChange = this.onCountryChange.bind(this);
    this.deleteAvailability = this.deleteAvailability.bind(this);
    this.deleteAvailabilityDialog = this.deleteAvailabilityDialog.bind(this);
    // this.checkZipCode = this.checkZipCode.bind(this);
    this.resetAvailabilityForm = this.resetAvailabilityForm.bind(this);
    this.resetAll = this.resetAll.bind(this);
    this.changePrimaryLocation = this.changePrimaryLocation.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onrenderimage = this.onrenderimage.bind(this);

    // this.handleDelete = this.handleDelete.bind(this);
    // this.handleAddition = this.handleAddition.bind(this);
    // this.handleDrag = this.handleDrag.bind(this);
    // this.handleTagClick = this.handleTagClick.bind(this);

    this.handleSaturdayMSTimeChange = this.handleSaturdayMSTimeChange.bind(
      this
    );
    this.handleSaturdayMETimeChange = this.handleSaturdayMETimeChange.bind(
      this
    );
    this.handleSaturdayESTimeChange = this.handleSaturdayESTimeChange.bind(
      this
    );
    this.handleSaturdayEETimeChange = this.handleSaturdayEETimeChange.bind(
      this
    );

    this.handleSundayMSTimeChange = this.handleSundayMSTimeChange.bind(this);
    this.handleSundayMETimeChange = this.handleSundayMETimeChange.bind(this);
    this.handleSundayESTimeChange = this.handleSundayESTimeChange.bind(this);
    this.handleSundayEETimeChange = this.handleSundayEETimeChange.bind(this);

    this.handleMondayMSTimeChange = this.handleMondayMSTimeChange.bind(this);
    this.handleMondayMETimeChange = this.handleMondayMETimeChange.bind(this);
    this.handleMondayESTimeChange = this.handleMondayESTimeChange.bind(this);
    this.handleMondayEETimeChange = this.handleMondayEETimeChange.bind(this);

    this.handleTuesdayMSTimeChange = this.handleTuesdayMSTimeChange.bind(this);
    this.handleTuesdayMETimeChange = this.handleTuesdayMETimeChange.bind(this);
    this.handleTuesdayESTimeChange = this.handleTuesdayESTimeChange.bind(this);
    this.handleTuesdayEETimeChange = this.handleTuesdayEETimeChange.bind(this);

    this.handleWednesdayMSTimeChange = this.handleWednesdayMSTimeChange.bind(
      this
    );
    this.handleWednesdayMETimeChange = this.handleWednesdayMETimeChange.bind(
      this
    );
    this.handleWednesdayESTimeChange = this.handleWednesdayESTimeChange.bind(
      this
    );
    this.handleWednesdayEETimeChange = this.handleWednesdayEETimeChange.bind(
      this
    );

    this.handleThursdayMSTimeChange = this.handleThursdayMSTimeChange.bind(
      this
    );
    this.handleThursdayMETimeChange = this.handleThursdayMETimeChange.bind(
      this
    );
    this.handleThursdayESTimeChange = this.handleThursdayESTimeChange.bind(
      this
    );
    this.handleThursdayEETimeChange = this.handleThursdayEETimeChange.bind(
      this
    );

    this.handleFridayMSTimeChange = this.handleFridayMSTimeChange.bind(this);
    this.handleFridayMETimeChange = this.handleFridayMETimeChange.bind(this);
    this.handleFridayESTimeChange = this.handleFridayESTimeChange.bind(this);
    this.handleFridayEETimeChange = this.handleFridayEETimeChange.bind(this);

    // this.geocoderZipcode = this.geocoderZipcode.bind(this);

    this.hideClinicViewModal = this.hideClinicViewModal.bind(this);
    this.showClinicViewModal = this.showClinicViewModal.bind(this);

    this.onLogoutclick = this.onLogoutclick.bind(this);
    this.timezones = this.timezones.bind(this);
    this.updateAddress = this.updateAddress.bind(this);
    this.onChange = this.onChange.bind(this);

    this._logout = this._logout.bind(this);
    // this.editProfile = this.editProfile.bind(this);
    // this.emailNotification = this.emailNotification.bind(this)
    this.onChangeConditionProcedure = this.onChangeConditionProcedure.bind(
      this
    );
  }

  _logout(event) {
    let userId = localStorage.getItem("userId");
    this.props.logoutAction.logout({ userId: userId });
    event.preventDefault();
    localStorage.clear();
    this.props.history.push("/");
  }
  updateAddress(address) {
    var placeSearch, autocomplete;
    var componentForm = {
      street_number: "",
      route: "",
      postal_town: "",
      locality: "",
      administrative_area_level_1: "",
      country: "",
      postal_code: "",
    };

    for (var i = 0; i < address.address_components.length; i++) {
      var addressType = address.address_components[i].types[0];
      if (componentForm[addressType] == '') {
        let val = address.address_components[i][componentForm[addressType]];
        componentForm[addressType] = address.address_components[i].long_name;
      }
    }

    let state = this.state;
    debugger
    if (componentForm.postal_code !== '') {
    state.Address = {
      value: componentForm.postal_code,
      isValid: true,
      message: "",
    }
  }else if (componentForm.locality !== '') {
      state.Address = {
        value: componentForm.locality,
        isValid: true,
        message: "",
      }
    } else if (componentForm.country !== '' || componentForm.postal_code !== '')
      state.Address = {
        value: componentForm.country,
        isValid: true,
        message: "",
      }
    if (componentForm.country !== '')
      state.country = {
        value: componentForm.country,
        isValid: true,
        message: "",
      };
    debugger
    if (componentForm.postal_code !== '')
      state.zipCode = {
        value: componentForm.postal_code,
        isValid: true,
        message: "",
      }
      state.city = {
        value:
          componentForm.postal_town != "Town"
            ? componentForm.postal_town
            : componentForm.locality != "locality"
            ? componentForm.locality
            : "",
        isValid: true,
        message: "",
      }
    state.stateName = {
      value:
        componentForm.administrative_area_level_1 != "State "
          ? componentForm.administrative_area_level_1
          : "",
      isValid: true,
      message: "",
    }
    
    state.addressLineOne = {
      value:
        componentForm.street_number != "Street Number"
          ? componentForm.street_number
          : "" + componentForm.route != "Route"
          ? componentForm.route
          : "",
      isValid: true,
      message: "",
    };
    debugger
    state.latitude = address.geometry.location.lat();
    state.longitude = address.geometry.location.lng();
    state.showNotificationDiv = true;
    state.isDisabled.country = state.country.value != "" ? true : false;
    state.isDisabled.state = state.stateName.value != "" ? true : false;
    state.isDisabled.city = state.city.value != "" ? true : false;

    this.setState(state);
  }
  showClinicViewModal(data) {
    this.setState({ viewClinicModal: true, viewClinicData: data });
  }

  hideClinicViewModal() {
    this.setState({ viewClinicModal: false });
  }

  enableEditMode(e) {
    console.log(e.target.className);
    if (e.target.className.includes("profile-edit-icon p-info")) {
      this.setState({ isDisablePI: false, editEnabled:true });
    }

    if (e.target.className.includes("profile-edit-icon p-back")) {
      this.setState({ isDisablePB: false, editEnabled:true });
    }

    if (e.target.className.includes("profile-edit-icon edu-info")) {
      this.setState({ isDisableES: false, editEnabled:true });
    }

    if (e.target.className.includes("profile-edit-icon awards")) {
      this.setState({ isDisableAM: false, editEnabled:true });
    }

    if (e.target.className.includes("profile-edit-icon p-sum")) {
      this.setState({ isDisablePS: false, editEnabled:true });
    }
  }

  handleSaturdayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.saturdayMorningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.saturdayMorningSchedule.message = "";

    state.saturdayMorningSchedule.startHour = hrs;
    state.saturdayMorningSchedule.startMinute = mins;
    state.saturdayMorningSchedule.endHour = this.state.saturdayMorningSchedule.endHour;
    state.saturdayMorningSchedule.endMinute = this.state.saturdayMorningSchedule.endMinute;
    state.saturdayMorningSchedule.outTime = this.state.saturdayMorningSchedule.outTime;

    if (mins == 30) {
      state.saturdayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.saturdayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleSaturdayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.saturdayMorningSchedule.inTime = this.state.saturdayMorningSchedule.inTime;
    state.saturdayMorningSchedule.message = "";

    state.saturdayMorningSchedule.startHour = this.state.saturdayMorningSchedule.startHour;
    state.saturdayMorningSchedule.startMinute = this.state.saturdayMorningSchedule.startMinute;
    state.saturdayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.saturdayMorningSchedule.endHour = hrs;
    state.saturdayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleSaturdayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.saturdayEveningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.saturdayEveningSchedule.startHour = hrs;
    state.saturdayEveningSchedule.message = "";

    state.saturdayEveningSchedule.startMinute = mins;
    state.saturdayEveningSchedule.endHour = this.state.saturdayEveningSchedule.endHour;
    state.saturdayEveningSchedule.endMinute = this.state.saturdayEveningSchedule.endMinute;
    state.saturdayEveningSchedule.outTime = this.state.saturdayEveningSchedule.outTime;
    if (mins == 30) {
      state.saturdayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.saturdayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleSaturdayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.saturdayEveningSchedule.inTime = this.state.saturdayEveningSchedule.inTime;
    state.saturdayEveningSchedule.message = "";

    state.saturdayEveningSchedule.startHour = this.state.saturdayEveningSchedule.startHour;
    state.saturdayEveningSchedule.startMinute = this.state.saturdayEveningSchedule.startMinute;
    state.saturdayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.saturdayEveningSchedule.endHour = hrs;
    state.saturdayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleSundayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.sundayMorningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.sundayMorningSchedule.message = "";

    state.sundayMorningSchedule.startHour = hrs;
    state.sundayMorningSchedule.startMinute = mins;
    state.sundayMorningSchedule.endHour = this.state.sundayMorningSchedule.endHour;
    state.sundayMorningSchedule.endMinute = this.state.sundayMorningSchedule.endMinute;
    state.sundayMorningSchedule.outTime = this.state.sundayMorningSchedule.outTime;

    if (mins == 30) {
      state.sundayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.sundayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleSundayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.sundayMorningSchedule.inTime = this.state.sundayMorningSchedule.inTime;
    state.sundayMorningSchedule.message = "";

    state.sundayMorningSchedule.startHour = this.state.sundayMorningSchedule.startHour;
    state.sundayMorningSchedule.startMinute = this.state.sundayMorningSchedule.startMinute;
    state.sundayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.sundayMorningSchedule.endHour = hrs;
    state.sundayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleSundayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.sundayEveningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.sundayEveningSchedule.message = "";

    state.sundayEveningSchedule.startHour = hrs;
    state.sundayEveningSchedule.startMinute = mins;
    state.sundayEveningSchedule.endHour = this.state.sundayEveningSchedule.endHour;
    state.sundayEveningSchedule.endMinute = this.state.sundayEveningSchedule.endMinute;
    state.sundayEveningSchedule.outTime = this.state.sundayEveningSchedule.outTime;
    if (mins == 30) {
      state.sundayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.sundayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleSundayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.sundayEveningSchedule.inTime = this.state.sundayEveningSchedule.inTime;
    state.sundayEveningSchedule.message = "";

    state.sundayEveningSchedule.startHour = this.state.sundayEveningSchedule.startHour;
    state.sundayEveningSchedule.startMinute = this.state.sundayEveningSchedule.startMinute;
    state.sundayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.sundayEveningSchedule.endHour = hrs;
    state.sundayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleMondayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.mondayMorningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.mondayMorningSchedule.message = "";
    state.mondayMorningSchedule.startHour = hrs;
    state.mondayMorningSchedule.startMinute = mins;
    state.mondayMorningSchedule.endHour = this.state.mondayMorningSchedule.endHour;
    state.mondayMorningSchedule.endMinute = this.state.mondayMorningSchedule.endMinute;
    state.mondayMorningSchedule.outTime = this.state.mondayMorningSchedule.outTime;

    if (mins == 30) {
      state.mondayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.mondayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleMondayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.mondayMorningSchedule.inTime = this.state.mondayMorningSchedule.inTime;
    state.mondayMorningSchedule.message = "";

    state.mondayMorningSchedule.startHour = this.state.mondayMorningSchedule.startHour;
    state.mondayMorningSchedule.startMinute = this.state.mondayMorningSchedule.startMinute;
    state.mondayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.mondayMorningSchedule.endHour = hrs;
    state.mondayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleMondayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.mondayEveningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.mondayEveningSchedule.message = "";

    state.mondayEveningSchedule.startHour = hrs;
    state.mondayEveningSchedule.startMinute = mins;
    state.mondayEveningSchedule.endHour = this.state.mondayEveningSchedule.endHour;
    state.mondayEveningSchedule.endMinute = this.state.mondayEveningSchedule.endMinute;
    state.mondayEveningSchedule.outTime = this.state.mondayEveningSchedule.outTime;
    if (mins == 30) {
      state.mondayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.mondayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleMondayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.mondayEveningSchedule.inTime = this.state.mondayEveningSchedule.inTime;
    state.mondayEveningSchedule.message = "";

    state.mondayEveningSchedule.startHour = this.state.mondayEveningSchedule.startHour;
    state.mondayEveningSchedule.startMinute = this.state.mondayEveningSchedule.startMinute;
    state.mondayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.mondayEveningSchedule.endHour = hrs;
    state.mondayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleTuesdayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.tuesdayMorningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.tuesdayMorningSchedule.message = "";

    state.tuesdayMorningSchedule.startHour = hrs;
    state.tuesdayMorningSchedule.startMinute = mins;
    state.tuesdayMorningSchedule.endHour = this.state.tuesdayMorningSchedule.endHour;
    state.tuesdayMorningSchedule.endMinute = this.state.tuesdayMorningSchedule.endMinute;
    state.tuesdayMorningSchedule.outTime = this.state.tuesdayMorningSchedule.outTime;

    if (mins == 30) {
      state.tuesdayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.tuesdayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleTuesdayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.tuesdayMorningSchedule.inTime = this.state.tuesdayMorningSchedule.inTime;
    state.tuesdayMorningSchedule.message = "";

    state.tuesdayMorningSchedule.startHour = this.state.tuesdayMorningSchedule.startHour;
    state.tuesdayMorningSchedule.startMinute = this.state.tuesdayMorningSchedule.startMinute;
    state.tuesdayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.tuesdayMorningSchedule.endHour = hrs;
    state.tuesdayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleTuesdayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.tuesdayEveningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.tuesdayEveningSchedule.message = "";

    state.tuesdayEveningSchedule.startHour = hrs;
    state.tuesdayEveningSchedule.startMinute = mins;
    state.tuesdayEveningSchedule.endHour = this.state.tuesdayEveningSchedule.endHour;
    state.tuesdayEveningSchedule.endMinute = this.state.tuesdayEveningSchedule.endMinute;
    state.tuesdayEveningSchedule.outTime = this.state.tuesdayEveningSchedule.outTime;
    if (mins == 30) {
      state.tuesdayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.tuesdayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleTuesdayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.tuesdayEveningSchedule.inTime = this.state.tuesdayEveningSchedule.inTime;
    state.tuesdayEveningSchedule.message = "";

    state.tuesdayEveningSchedule.startHour = this.state.tuesdayEveningSchedule.startHour;
    state.tuesdayEveningSchedule.startMinute = this.state.tuesdayEveningSchedule.startMinute;
    state.tuesdayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.tuesdayEveningSchedule.endHour = hrs;
    state.tuesdayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleWednesdayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.wednesdayMorningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.wednesdayMorningSchedule.message = "";

    state.wednesdayMorningSchedule.startHour = hrs;
    state.wednesdayMorningSchedule.startMinute = mins;
    state.wednesdayMorningSchedule.endHour = this.state.wednesdayMorningSchedule.endHour;
    state.wednesdayMorningSchedule.endMinute = this.state.wednesdayMorningSchedule.endMinute;
    state.wednesdayMorningSchedule.outTime = this.state.wednesdayMorningSchedule.outTime;

    if (mins == 30) {
      state.wednesdayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.wednesdayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleWednesdayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.wednesdayMorningSchedule.inTime = this.state.wednesdayMorningSchedule.inTime;
    state.wednesdayMorningSchedule.message = "";
    state.wednesdayMorningSchedule.startHour = this.state.wednesdayMorningSchedule.startHour;
    state.wednesdayMorningSchedule.startMinute = this.state.wednesdayMorningSchedule.startMinute;
    state.wednesdayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.wednesdayMorningSchedule.endHour = hrs;
    state.wednesdayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleWednesdayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.wednesdayEveningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.wednesdayEveningSchedule.startHour = hrs;
    state.wednesdayEveningSchedule.startMinute = mins;
    state.wednesdayEveningSchedule.endHour = this.state.wednesdayEveningSchedule.endHour;
    state.wednesdayEveningSchedule.endMinute = this.state.wednesdayEveningSchedule.endMinute;
    state.wednesdayEveningSchedule.outTime = this.state.wednesdayEveningSchedule.outTime;
    if (mins == 30) {
      state.wednesdayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.wednesdayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleWednesdayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.wednesdayEveningSchedule.inTime = this.state.wednesdayEveningSchedule.inTime;
    state.wednesdayEveningSchedule.message = "";

    state.wednesdayEveningSchedule.startHour = this.state.wednesdayEveningSchedule.startHour;
    state.wednesdayEveningSchedule.startMinute = this.state.wednesdayEveningSchedule.startMinute;
    state.wednesdayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.wednesdayEveningSchedule.endHour = hrs;
    state.wednesdayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleThursdayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.thursdayMorningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.thursdayMorningSchedule.message = "";

    state.thursdayMorningSchedule.startHour = hrs;
    state.thursdayMorningSchedule.startMinute = mins;
    state.thursdayMorningSchedule.endHour = this.state.thursdayMorningSchedule.endHour;
    state.thursdayMorningSchedule.endMinute = this.state.thursdayMorningSchedule.endMinute;
    state.thursdayMorningSchedule.outTime = this.state.thursdayMorningSchedule.outTime;

    if (mins == 30) {
      state.thursdayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.thursdayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleThursdayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.thursdayMorningSchedule.inTime = this.state.thursdayMorningSchedule.inTime;
    state.thursdayMorningSchedule.message = "";

    state.thursdayMorningSchedule.startHour = this.state.thursdayMorningSchedule.startHour;
    state.thursdayMorningSchedule.startMinute = this.state.thursdayMorningSchedule.startMinute;
    state.thursdayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.thursdayMorningSchedule.endHour = hrs;
    state.thursdayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleThursdayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.thursdayEveningSchedule.inTime =
      hrs.toString() + ":" + mins.toString();
    state.thursdayEveningSchedule.message = "";

    state.thursdayEveningSchedule.startHour = hrs;
    state.thursdayEveningSchedule.startMinute = mins;
    state.thursdayEveningSchedule.endHour = this.state.thursdayEveningSchedule.endHour;
    state.thursdayEveningSchedule.endMinute = this.state.thursdayEveningSchedule.endMinute;
    state.thursdayEveningSchedule.outTime = this.state.thursdayEveningSchedule.outTime;
    if (mins == 30) {
      state.thursdayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.thursdayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleThursdayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.thursdayEveningSchedule.inTime = this.state.thursdayEveningSchedule.inTime;
    state.thursdayEveningSchedule.message = "";

    state.thursdayEveningSchedule.startHour = this.state.thursdayEveningSchedule.startHour;
    state.thursdayEveningSchedule.startMinute = this.state.thursdayEveningSchedule.startMinute;
    state.thursdayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.thursdayEveningSchedule.endHour = hrs;
    state.thursdayEveningSchedule.endMinute = mins;
    this.setState(state);
  }
  handleFridayMSTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.fridayMorningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.fridayMorningSchedule.message = "";

    state.fridayMorningSchedule.startHour = hrs;
    state.fridayMorningSchedule.startMinute = mins;
    state.fridayMorningSchedule.endHour = this.state.fridayMorningSchedule.endHour;
    state.fridayMorningSchedule.endMinute = this.state.fridayMorningSchedule.endMinute;
    state.fridayMorningSchedule.outTime = this.state.fridayMorningSchedule.outTime;

    if (mins == 30) {
      state.fridayMornETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.fridayMornETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }

    this.setState(state);
  }
  handleFridayMETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.fridayMorningSchedule.inTime = this.state.fridayMorningSchedule.inTime;
    state.fridayMorningSchedule.message = "";

    state.fridayMorningSchedule.startHour = this.state.fridayMorningSchedule.startHour;
    state.fridayMorningSchedule.startMinute = this.state.fridayMorningSchedule.startMinute;
    state.fridayMorningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.fridayMorningSchedule.endHour = hrs;
    state.fridayMorningSchedule.endMinute = mins;
    this.setState(state);
  }

  handleFridayESTimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.fridayEveningSchedule.inTime = hrs.toString() + ":" + mins.toString();
    state.fridayEveningSchedule.message = "";

    state.fridayEveningSchedule.startHour = hrs;
    state.fridayEveningSchedule.startMinute = mins;
    state.fridayEveningSchedule.endHour = this.state.fridayEveningSchedule.endHour;
    state.fridayEveningSchedule.endMinute = this.state.fridayEveningSchedule.endMinute;
    state.fridayEveningSchedule.outTime = this.state.fridayEveningSchedule.outTime;
    if (mins == 30) {
      state.fridayEvenETValid.start = (hrs + 1).toString() + ":00";
    } else {
      state.fridayEvenETValid.start =
        hrs.toString() + ":" + (mins + 30).toString();
    }
    this.setState(state);
  }

  handleFridayEETimeChange(time) {
    var hrs = parseInt(time / 3600);
    if (hrs < 10) {
      hrs = "0" + hrs;
    }
    var mins = (time - hrs * 3600) / 60;
    if (mins == 0) {
      mins = "00";
    }
    var state = this.state;
    state.fridayEveningSchedule.inTime = this.state.fridayEveningSchedule.inTime;
    state.fridayEveningSchedule.message = "";

    state.fridayEveningSchedule.startHour = this.state.fridayEveningSchedule.startHour;
    state.fridayEveningSchedule.startMinute = this.state.fridayEveningSchedule.startMinute;
    state.fridayEveningSchedule.outTime =
      hrs.toString() + ":" + mins.toString();
    state.fridayEveningSchedule.endHour = hrs;
    state.fridayEveningSchedule.endMinute = mins;
    this.setState(state);
  }

  changePrimaryLocation(event) {
    console.log(
      "===initial<>>",
      // this.state,
      this.state.isPrimary,
      event.target.value,
      event.target.name
    );
    var checkbox = event.target.name
      
    if (this.state.clinicInfo.length > 0) {
      var state = this.state;

      let flag =
        event.target.value == "false" || event.target.value == ""
          ? "false"
          : "true";
      // state[event.target.name].value = flag == "false" ? "true" : "false";
      console.log('event',event.target.value,event.target.name)
      if (event.target.value == "false") {

        this.setState({
          designatePrimaryDialog:true,
          // isPrimary:event.target.value
        })


        // confirmAlert({
        //   title: "Confirm",
        //   message:
        //     "Designate this location as your primary clinic address?",
        //   buttons: [
        //     {
        //       label: "Yes",
        //       onClick: () => {

        //         // for(let i=0;i<state.clinicInfo.length;i++){
        //         //   if(state.availId === state.clinicInfo[i]._id){
        //         //       state.clinicInfo[i].isPrimaryAddress = true
        //         //   }
        //         //   else{
        //         //     state.clinicInfo[i].isPrimaryAddress = false
        //         //   }
        //         // }
        //         this.setState(state);
        //         toast.info("Your Primary Address changes are being applied");
        //       },
        //     },
        //     {
        //       label: "No",
        //       onClick: () => {
        //         var state = this.state
        //     state[checkbox].value = "false"
        //     this.setState(state)
        //       },
        //     },
        //   ],
        // });





      } else{
        this.setState({
          isPrimary:{
            value: "false"
          }
        });
      }
        
    } else {
      var state = this.state;

      let flag =
        event.target.value == "false" || event.target.value == ""
          ? "false"
          : "true";
      state[event.target.name].value = flag == "false" ? "true" : "false";
      this.setState(state, () => {
        console.log("===<>else part>", this.state.isPrimary);
      });
      // toast.info('Your Primary Address changes are being applied');
    }
  }

  timezones(timezone) {
    var state = this.state;
    // if(timezone == 'Asia/Calcutta'){
    // 	timezone = 'Asia/Kolkata';
    // }
    state.timezoner = { value: timezone, isValid: true, message: "" };
    this.setState(state);
  }

  resetAll() {
    var state = this.state;
    (state.specialistInfo = {}), (state.isNotReset = false);
    (state.modalIsOpen = false),
      (state.userName = { value: "", isValid: true, message: "" }),
      (state.phoneNo = { value: "", isValid: true, message: "" }),
      (state.gender = { value: "Male", isValid: true, message: "" }),
      (state.email = { value: "", isValid: true, message: "" }),
      (state.image = { value: "", isValid: true, message: "" }),
      (state.yearExperience = { value: "", isValid: true, message: "" }),
      (state.subSpecializationList = []),
      (state.specialization = { value: "", isValid: true, message: "" }),
      (state.registrationNo = { value: "", isValid: true, message: "" }),
      (state.phoneNoCountryCode = {
        value: "",
        isValid: true,
        message: "",
      }),
      (state.qualification = { value: "", isValid: true, message: "" }),
      (state.monthExperience = { value: "", isValid: true, message: "" }),
      (state.consultationErrMsg = ""),
      (state.subSpecialization = { value: "", isValid: true, message: "" }),
      (state.profileSummary = { value: "", isValid: true, message: "" }),
      (state.academics = { value: "", isValid: true, message: "" }),
      (state.professionalAward = { value: "", isValid: true, message: "" }),
      // state.tags = [];
      (state.consultationErrMsg = "");
    state.zipcodeMatch = true;
    //for instead reflect image change

    (state.imageCopy = ""), (state.file = ""), (state.imagePreviewUrl = "");
    this.setState(state);
  }



  editAvailability(index) {
    var obj = this.state.clinicInfo[index];
    var state = this.state;
    state.stateErrorCode = 0;
    state.indexOfSelectedClinic = index;
    state.successMsg = "";
    state.editClinic = true;
    //Clinic Banner Image
    // state.clinicBanner = obj.clinicBanner

    state["clinicName"] = { value: obj.clinicName, message: "", isValid: true };
    state["timezoner"] = { value: obj.contryzone, message: "", isValid: true };
    state["addressLineOne"] = {
      value: obj.addressLineOne,
      message: "",
      isValid: true,
    };
    state["clinicBannerImage"] = obj.clinicBannerImage
    state["saturday"] = { value: obj.saturday, message: "", isValid: true };
    state["sunday"] = { value: obj.sunday, message: "", isValid: true };
    state["monday"] = { value: obj.monday, message: "", isValid: true };
    state["tuesday"] = { value: obj.tuesday, message: "", isValid: true };
    state["wednesday"] = { value: obj.wednesday, message: "", isValid: true };
    state["thursday"] = { value: obj.thursday, message: "", isValid: true };
    state["friday"] = { value: obj.friday, message: "", isValid: true };
    state["country"] = {
      value: obj.country,
      message: "",
      isValid: true,
    };
    state["saturdayMorning"] = {
      value: obj.saturdayMorning,
      message: "",
      isValid: true,
    };
    state["saturdayEvening"] = {
      value: obj.saturdayEvening,
      message: "",
      isValid: true,
    };

    state["sundayMorning"] = {
      value: obj.sundayMorning,
      message: "",
      isValid: true,
    };
    state["sundayEvening"] = {
      value: obj.sundayEvening,
      message: "",
      isValid: true,
    };

    state["mondayMorning"] = {
      value: obj.mondayMorning,
      message: "",
      isValid: true,
    };
    state["mondayEvening"] = {
      value: obj.mondayEvening,
      message: "",
      isValid: true,
    };

    state["tuesdayMorning"] = {
      value: obj.tuesdayMorning,
      message: "",
      isValid: true,
    };
    state["tuesdayEvening"] = {
      value: obj.tuesdayEvening,
      message: "",
      isValid: true,
    };

    state["wednesdayMorning"] = {
      value: obj.wednesdayMorning,
      message: "",
      isValid: true,
    };
    state["wednesdayEvening"] = {
      value: obj.wednesdayEvening,
      message: "",
      isValid: true,
    };

    state["thursdayMorning"] = {
      value: obj.thursdayMorning,
      message: "",
      isValid: true,
    };
    state["thursdayEvening"] = {
      value: obj.thursdayEvening,
      message: "",
      isValid: true,
    };

    state["fridayMorning"] = {
      value: obj.fridayMorning,
      message: "",
      isValid: true,
    };
    state["fridayEvening"] = {
      value: obj.fridayEvening,
      message: "",
      isValid: true,
    };
    state["zipcodeMatch"] = true;

    state["phoneCode1"] = {
      value: obj.phoneCode1,
      message: "",
      isValid: true,
    };
    state["phoneCodeList"] = constant.PHONENOCOUNTRYCODE;
    state["phoneCode2"] = {
      value: obj.phoneCode2,
      message: "",
      isValid: true,
    };
    state["currencySymbol"] = {
      value: obj.currencySymbol,
      message: "",
      isValid: true,
    };
    state["fee"] = {
      value: obj.fee,
      message: "",
      isValid: true,
    };
    state["city"] = {
      value: obj.city,
      message: "",
      isValid: true,
    };
    state["zipCode"] = {
      value: obj.zipCode,
      message: "",
      isValid: true,
    };
    state["Address"] = {
      value: obj.zipCode,
      message: "",
      isValid: true,
    };
    state["stateName"] = {
      value: obj.state,
      message: "",
      isValid: true,
    };
    this.setState(state);
    // let countryObj = {
    // 	countryId: obj.countryId
    // };

    state["stateName"] = {
      value: obj.state,
      message: "",
      isValid: true,
    };

    state["mobileNo"] = { value: obj.mobileNo, message: "", isValid: true };
    state["telephoneNo"] = {
      value: obj.telephoneNo,
      message: "",
      isValid: true,
    };
    state.modalIsOpen = true;
    state.countryList = [];
    state.stateList = obj.stateList;
    state.currencyList = constant.CURRENCY;
    state.isFromEdit = true;
    state.editIndex = index;
    state.availId = obj._id;

    if (obj._id != "" || obj._id != undefined) {
      if (obj.sunday == true && obj.sundayMornInTime) {
        state["sundayMorningSchedule"].inTime = obj.sundayMornInTime;
        state["sundayMorningSchedule"].outTime = obj.sundayMornOutTime;
        state["sundayEveningSchedule"].inTime = obj.sundayEvenInTime;
        state["sundayEveningSchedule"].outTime = obj.sundayEvenOutTime;

        state["sundayMornETValid"] = {
          start: obj.sundayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["sundayEvenETValid"] = {
          start: obj.sundayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      if (obj.monday == true && obj.mondayMornInTime) {
        state["mondayMorningSchedule"].inTime = obj.mondayMornInTime;
        state["mondayMorningSchedule"].outTime = obj.mondayMornOutTime;
        state["mondayEveningSchedule"].inTime = obj.mondayEvenInTime;
        state["mondayEveningSchedule"].outTime = obj.mondayEvenOutTime;

        state["mondayMornETValid"] = {
          start: obj.mondayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["mondayEvenETValid"] = {
          start: obj.mondayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      if (obj.tuesday == true && obj.tuesdayMornInTime) {
        state["tuesdayMorningSchedule"].inTime = obj.tuesdayMornInTime;
        state["tuesdayMorningSchedule"].outTime = obj.tuesdayMornOutTime;
        state["tuesdayEveningSchedule"].inTime = obj.tuesdayEvenInTime;
        state["tuesdayEveningSchedule"].outTime = obj.tuesdayEvenOutTime;

        state["tuesdayMornETValid"] = {
          start: obj.tuesdayMornETValid,
          end: constant.MORNING_START.END,
        };
        state["tuesdayEvenETValid"] = {
          start: constant.EVENING_START.START,
          end: obj.tuesdayEvenETValid,
        };
      }

      if (obj.wednesday == true && obj.wednesdayMornInTime) {
        state["wednesdayMorningSchedule"].inTime = obj.wednesdayMornInTime;
        state["wednesdayMorningSchedule"].outTime = obj.wednesdayMornOutTime;
        state["wednesdayEveningSchedule"].inTime = obj.wednesdayEvenInTime;
        state["wednesdayEveningSchedule"].outTime = obj.wednesdayEvenOutTime;

        state["wednesdayMornETValid"] = {
          start: obj.wednesdayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["wednesdayEvenETValid"] = {
          start: obj.wednesdayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      if (obj.thursday == true && obj.thursdayMornInTime) {
        state["thursdayMorningSchedule"].inTime = obj.thursdayMornInTime;
        state["thursdayMorningSchedule"].outTime = obj.thursdayMornOutTime;
        state["thursdayEveningSchedule"].inTime = obj.thursdayEvenInTime;
        state["thursdayEveningSchedule"].outTime = obj.thursdayEvenOutTime;

        state["thursdayMornETValid"] = {
          start: obj.thursdayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["thursdayEvenETValid"] = {
          start: obj.thursdayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      if (obj.friday == true && obj.fridayMornInTime) {
        state["fridayMorningSchedule"].inTime = obj.fridayMornInTime;
        state["fridayMorningSchedule"].outTime = obj.fridayMornOutTime;
        state["fridayEveningSchedule"].inTime = obj.fridayEvenInTime;
        state["fridayEveningSchedule"].outTime = obj.fridayEvenOutTime;

        state["fridayMornETValid"] = {
          start: obj.fridayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["fridayEvenETValid"] = {
          start: obj.fridayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      if (obj.saturday == true && obj.saturdayMornInTime) {
        state["saturdayMorningSchedule"].inTime = obj.saturdayMornInTime;
        state["saturdayMorningSchedule"].outTime = obj.saturdayMornOutTime;
        state["saturdayEveningSchedule"].inTime = obj.saturdayEvenInTime;
        state["saturdayEveningSchedule"].outTime = obj.saturdayEvenOutTime;

        state["saturdayMornETValid"] = {
          start: obj.saturdayMornETValid,
          end: constant.MORNING_START.END,
        };

        state["saturdayEvenETValid"] = {
          start: obj.saturdayEvenETValid,
          end: constant.EVENING_END.END,
        };
      }

      state.longitude = obj.location.coordinates[0];
      state.latitude = obj.location.coordinates[1];
    }

    state["isPrimary"] = {
      value: obj.isPrimaryAddress == true ? "true" : "false",
    };

    this.setState(state);
  }

  openModal() {
    if (this.state.specialization.value != "") {
      this.resetAvailabilityForm();
      this.setState({ modalIsOpen: true, successMsg: "" });
    } else {
      console.log('Please select specialization to proceed ahead')
      this.setState(
        { consultationErrMsg: "Please select specialization to proceed ahead" },
        () => {
          this.resetAvailabilityForm();
        }
      );

      setTimeout(()=>{
        this.setState({consultationErrMsg:""})
      },5000)
    }
  }

  openModalForLanguage = () => {
    this.setState({
      openLanguageModal: true,
    });
  };

  closeLanguageModal = () => {
    this.setState({
      openLanguageModal: false,
    });
    this.props.actions.saveLanguageToSpecialist({
      userId: localStorage.getItem("userId"),
      languages: this.state.languages,
    });
  };
  closeModal() {
    var state = this.state;
    state.tempUpClinicBanner = "";
    state.Address.value = "";
    state.tempBannerImage = "";
    state.clinicBannerObj = "";
    state.clinicBannerImage = "";
    state.mondayMorningSchedule.message = "";
    state.mondayEveningSchedule.message = "";
    state.tuesdayMorningSchedule.message = "";
    state.tuesdayEveningSchedule.message = "";
    state.wednesdayMorningSchedule.message = "";
    state.wednesdayEveningSchedule.message = "";
    state.thursdayMorningSchedule.message = "";
    state.thursdayEveningSchedule.message = "";
    state.fridayMorningSchedule.message = "";
    state.fridayEveningSchedule.message = "";
    state.saturdayMorningSchedule.message = "";
    state.saturdayEveningSchedule.message = "";
    state.sundayMorningSchedule.message = "";
    state.sundayEveningSchedule.message = "";
    state.mondayMorning.value = true;
    state.mondayEvening.value = true;
    state.tuesdayMorning.value = true;
    state.tuesdayEvening.value = true;
    state.wednesdayMorning.value = true;
    state.wednesdayEvening.value = true;
    state.thursdayMorning.value = true;
    state.thursdayEvening.value = true;
    state.fridayMorning.value = true;
    state.fridayEvening.value = true;
    state.saturdayMorning.value = true;
    state.saturdayEvening.value = true;
    state.sundayMorning.value = true;
    state.sundayEvening.value = true;

    this.setState(state);
    this.setState({
      modalIsOpen: false,
      zipcodeMatch: true,
      showNotificationDiv: false,
    });
  }
  onSpecializationChange(event) {
    var state = this.state;
    this.state.isDirty = true
    console.log(event.target.value)
    if (event.target.name == "specialization") {
      state.conditionProcedure = []
      state.isVettingTriggered = true;
      if (event.target.value == "") {
        state.specialization.isValid = false;
        state.specialization.message = "Specialization is required";
        state.specialization.value = event.target.value;
        state.subSpecialization.value = "";
        state.conditionProcedure = []
        state.conditionProcedureMsg=""
        state.noConditionProcedure = false
        // state.tags = [];
        this.setState(state);
      } 
      else if(event.target.value =="5afec94938706768c36f1125" || event.target.value =="5b0fc3d93c0f9c1748864657" ){

        state.noConditionProcedure = true
        state.specialization.isValid = true;
        state.specialization.message = "";
        state.consultationErrMsg = "";
        state.conditionProcedureMsg=""
        state.specialization.value = event.target.value;
        state.subSpecialization.value = "";
        state.conditionProcedure = []

        state.isOnloadSpecialization = false;
        this.setState(state);
      }
      else {
        state.specialization.isValid = true;
        state.specialization.message = "";
        state.consultationErrMsg = "";
        state.conditionProcedureMsg=""
        state.noConditionProcedure = false
        state.specialization.value = event.target.value;
        state.subSpecialization.value = "";
        state.conditionProcedure = []

        state.isOnloadSpecialization = false;
        this.setState(state);
      }
    } else if ((event.target.name = "subSpecialization")) {
      state.subSpecialization.value = event.target.value;
      // state.isVettingTriggered = false
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Atleast add one Sub Speciality";
        state[event.target.name].value = event.target.value;
        // state.conditionProcedure = []
        this.setState(state);
      } 
      else if (
        state.subSpecialization.value == "" &&
        state.subSpecializationList.length == 0
      ) {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Select specialization first";
      } 
      else if (!validator.isOnlyAlphaNComma(state.subSpecialization.value)) {
        state.subSpecialization.isValid = false;
        state.subSpecialization.message =
          "Only alphabets & comma are allowed in Sub Speciality";
        this.setState(state);
      } else if (state.subSpecialization.value.length > 300) {
        state.specialization.isValid = false;
        state.subSpecialization.message =
          "Character count exceeded " +
          state.subSpecialization.value.length +
          "/300";
        this.setState(state);
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message =
          "";
        // state.disabled = false;
        this.setState(state);
      }
    }
  }
  changeInAvailability(event) {
    console.log(event.target);
    var state = this.state;

    if (
      event.target.name == "clinicName" ||
      event.target.name == "addressLineOne" ||
      event.target.name == "stateName" ||
      event.target.name == "city" ||
      event.target.name == "country"
    ) {
      state.showNotificationDiv = true;
      state.addressChange = true;
    } else {
      state.showNotificationDiv = false;
    }

    if (
      event.target.name == "saturday" ||
      event.target.name == "sunday" ||
      event.target.name == "monday" ||
      event.target.name == "tuesday" ||
      event.target.name == "wednesday" ||
      event.target.name == "thursday" ||
      event.target.name == "friday"
    ) {
      let flag = event.target.value == "false" || event.target.value == "";

      state[event.target.name].value = flag == true ? true : false;

      // if (!flag) {
      state[event.target.name + "MornSTValid"] = {
        start: constant.MORNING_START.START,
        end: constant.MORNING_START.END,
      };

      state[event.target.name + "MornETValid"] = {
        start: constant.MORNING_END.START,
        end: constant.MORNING_END.END,
      };
      state[event.target.name + "EvenSTValid"] = {
        start: constant.EVENING_START.START,
        end: constant.EVENING_START.END,
      };
      state[event.target.name + "EvenETValid"] = {
        start: constant.EVENING_END.START,
        end: constant.EVENING_END.END,
      };

      state[event.target.name + "MorningSchedule"] = {
        inTime: "08:00",
        outTime: "11:30",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      };
      state[event.target.name + "EveningSchedule"] = {
        inTime: "17:00",
        outTime: "22:00",
        startHour: 15,
        startMinute: 10,
        endHour: 5,
        endMinute: 10,
        isValid: true,
        message: "",
      };
      // state[event.target.name + 'Evening'].value = flag == true ? false : true;
      // state[event.target.name + 'Morning'].value = flag == true ? false : true;

      this.setState(state);

      // }
    } else {
      state[event.target.name].value = event.target.value;
      this.setState(state);
    }

    if (
      event.target.name == "saturdayMorning" ||
      event.target.name == "saturdayEvening" ||
      event.target.name == "mondayMorning" ||
      event.target.name == "mondayEvening" ||
      event.target.name == "tuesdayMorning" ||
      event.target.name == "tuesdayEvening" ||
      event.target.name == "wednesdayMorning" ||
      event.target.name == "wednesdayEvening" ||
      event.target.name == "thursdayMorning" ||
      event.target.name == "thursdayEvening" ||
      event.target.name == "fridayMorning" ||
      event.target.name == "fridayEvening" ||
      event.target.name == "sundayMorning" ||
      event.target.name == "sundayEvening"
    ) {
      let flag = event.target.value == "false" || event.target.value == "";

      state[event.target.name].value = flag == true ? true : false;

      this.setState(state);
    }

    //validation code
    if (event.target.name == "clinicName") {
      if (event.target.value.length > 0) {
        state.isVettingTriggered = true;
        if (!validator.isValidName(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Please enter a valid  clinic name";
        } else if (event.target.value.length > 60) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Max clinic name allowed size is 40 characters";
        } else {
          state[event.target.name].isValid = true;
          state.clinicName.message = "";
        }
      } else {
        state.isVettingTriggered = true;
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Clinic name is Required";
      }
    } else if (event.target.name == "mobileNo") {
      if (event.target.value.length > 0 && event.target.value !== "") {
        if (!validator.isOnlyNumber(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Only numbers are allowed in Mobile number";
        } else if (event.target.value.length > 10) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Max 10 digits are allowed in Mobile number";
        }
        //  else if (state.phoneCode1.value == '') {
        // 	state.phoneCode1.isValid = false;
        // 	state.phoneCode1.message = 'Landline number code is required';
        // 	state[event.target.name].isValid = true;
        // 	state[event.target.name].message = '';
        // }
        else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
          state.phoneCode1.isValid = true;
          state.phoneCode1.message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Mobile number is required";
      }
    } else if (event.target.name == "telephoneNo") {
      if (event.target.value.length > 0) {
        if (!validator.isOnlyNumber(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            " Only numbers are allowed in mobile number";
        } else if (event.target.value.length > 10) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            " Max 10 digits are allowed in mobile number";
        } else if (state.phoneCode2.value == "") {
          state.phoneCode2.isValid = false;
          state.phoneCode2.message = "Please select Country Code";
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
          state.phoneCode2.isValid = true;
          state.phoneCode2.message = "";
        }
      }
    } else if (event.target.name == "phoneCode1") {
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Please select Country Code";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      }
    } else if (event.target.name == "phoneCode2") {
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Please select Country Code";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      }
    } else if (event.target.name == "addressLineOne") {
      if (state[event.target.name].value.length > 0) {
        if (state[event.target.name].value.length > 70) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Max allowed limit is 70 characters";
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Consultation address is required";
      }
    } else if (event.target.name == "city") {
      if (state[event.target.name].value.length > 0) {
        if (!validator.isValidName(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Please enter a valid city";
        } else if (state[event.target.name].value.length > 30) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Max allowed limit is 30 characters";
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "City is required";
      }
    } else if (event.target.name == "fee") {
      if (event.target.value.length > 0 && event.target.value !== "") {
        if (!validator.isOnlyNumber(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Only numbers are allowed in Fee";
        } else if (event.target.value.length > 10) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Max 10 digits are allowed in Fee";
        } else if (state.currencySymbol.value == "") {
          state.currencySymbol.isValid = false;
          state.currencySymbol.message = "Currency symbol is required";
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
          state.currencySymbol.isValid = true;
          state.currencySymbol.message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Fee is required";
      }
    } else if (event.target.name == "currencySymbol") {
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Currency symbol is required";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      }
    } else if (event.target.name == "currencySymbol") {
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Currency symbol is required";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      }
    } else if (
      event.target.name == "saturday" ||
      event.target.name == "sunday" ||
      event.target.name == "monday" ||
      event.target.name == "tuesday" ||
      event.target.name == "wednesday" ||
      event.target.name == "thursday" ||
      event.target.name == "friday"
    ) {
      if (
        state.monday.value == false &&
        state.tuesday.value == false &&
        state.wednesday.value == false &&
        state.thursday.value == false &&
        state.friday.value == false &&
        state.saturday.value == false &&
        state.sunday.value == false
      ) {
        state.friday.isValid = false;
        state.friday.message = "Select atleast one consultation day";
      } else {
        state.friday.isValid = true;
        state.friday.message = "";
      }
    } else if (event.target.name == "stateName") {
      if (event.target.value.length > 0 && event.target.value !== "") {
        if (!validator.isValidName(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Please enter a valid state";
        } else if (state[event.target.name].value.length > 50) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Max allowed limit is 50 characters";
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "State is required";
      }
    }

    this.setState(state);
  }
  onrenderimage() {
    if (
      this.state.imageCopy == "" ||
      this.state.imageCopy == "noUserImage.jpg"
    ) {
      if (this.state.gender.value == "Male") {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png";
      } else {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
      }
    } else {
      this.state.defaultImageURL =
        constant.PRODUCTION_IMAGE_URL +
        constant.UPLOAD_FOLDER +
        // "/" +
        localStorage.getItem("userId") +
        "/" +
        this.state.imageCopy;
    }
  }
  onChange(event, index = null) {
    var state = this.state;
    
    if (
      event.target.name == "academics" ||
      event.target.name == "qualifications"
    ) {
      let tempObj = this.state.EduSummary;
      if (event.target.name == "academics") {
        tempObj[index].academics = event.target.value;
      } else if (event.target.name == "qualifications") {
        tempObj[index].qualifications = event.target.value;
      }

      this.setState({ EduSummary: tempObj });
    }

    if (event.target.name == "professionalAward") {
      let tempObj = this.state.Awards;
      console.log("event", event.target.value);
      tempObj[index].value = event.target.value;
      console.log(tempObj);

      this.setState({ Awards: tempObj });
    } else if (event.target.name == "") {
      state[event.target.name].value = event.target.value;
    }

    if (
      event.target.name !== "professionalAward" &&
      event.target.name !== "academics" &&
      event.target.name !== "qualifications"
    ) {
      state[event.target.name].value = event.target.value;
    }

    

    if (event.target.name == "gender") {
      state.isVettingTriggered = true;
      if (event.target.value == "Male") {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png";
      } else {
        this.state.defaultImageURL =
          constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";
      }
    }

    if (event.target.name == "profileSummary") {
      if (event.target.value == "") {
        state[event.target.name].isValid = false;
        state[event.target.name].message =
          "Please enter a valid Profile Summary";
      } else {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
        // state[event.target.name].value = event.target.value
      }
      if (event.target.value.length > 2000) {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Character count exceeded";
      }
    }

    if (event.target.name == "userName") {
      state.isVettingTriggered = true;
      if (event.target.value.length > 0) {
        if (!validator.isValidName(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message = "Please enter a valid name";
        } else {
          state[event.target.name].isValid = true;
          state.userName.message = "";
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Name is Required";
      }
    } 
    

 
    else if (event.target.name == "registrationNo") {
      if (event.target.value != "") {
        if (!validator.isOnlyAlphaNumeric(event.target.value)) {
          state[event.target.name].isValid = false;
          state[event.target.name].message =
            "Only alpha numeric characters are allowed in registration number";
          this.setState(state);
        } else {
          state[event.target.name].isValid = true;
          state[event.target.name].message = "";
          state[event.target.name].value = event.target.value;
        }
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "Registration number is required";
      }
    } else if (event.target.name == "country") {
      if (event.target.value.length > 0) {
        state[event.target.name].isValid = true;
        state[event.target.name].message = "";
      } else {
        state[event.target.name].isValid = false;
        state[event.target.name].message = "country is required";
      }
    }
    state.isDirty = true
    this.setState(state);
  }
  uploadSpecialistImage(event) {
    //To change the view immediately after uploading image
    event.preventDefault();
    if (event.target.name == "image") {
      if (event.target.files.length > 0) {
        if (!validator.ImageValidateFormate(event.target.files[0])) {
          toast.error("Please choose following format jpeg, jpg, png, gif");
        } else if (!validator.fileValidateSize(event.target.files[0])) {
          toast.error("File size must be less than 10 MB.");
        } else {
          let reader = new FileReader();
          let file = event.target.files[0];

          reader.onloadend = () => {
            this.setState({
              file: file,
              defaultImageURL: reader.result,
            });
          };

          reader.readAsDataURL(file);
          this.setState({ [event.target.name]: event.target.files[0] });
          let specialistObj = {
            file: event.target.files[0],
            userId: localStorage.getItem("userId"),
          };

          this.setState({
            specialistImageObj: specialistObj,
            tempImageObj: URL.createObjectURL(event.target.files[0]),
            isDirty: true
          });
          // this.uploadTempImage( URL.createObjectURL(event.target.files[0]))

          // banna made this func this.setState({uploadedSpecialistImageObj: specialistObj });
        }
      }
    }
  }

  uploadTempImage = () => {
    this.setState({
      tempUploadedImage: this.state.tempImageObj,
    });
    toast.info("Image Uploaded");
    this.handleClose();
  };

  submitUploadedSpecialistImg = () => {
    console.log("clicked");

    this.props.actions.uploadSpecialistImage(this.state.specialistImageObj);
    this.setState({ firstRun: true, imagePreviewUrl:"" });
    this.handleClose();

  };



  UploadClinicBanner = (tempImageObj, clinicImageObj) => {
    this.setState({
      tempUpClinicBanner: tempImageObj,
      clinicImageObj: clinicImageObj,
      clinicBannerImageDeleted: false,
    })
    return
  }

  handleCloseBannerModal = (event) => {
    this.setState({
      tempBannerImage : ""
    })
  }


  removeClinicBanner(event) {
    console.log('here')
    this.setState({
      tempUpClinicBanner: null,
      clinicBannerObj: null,
      clinicBannerImageDeleted: true,
      clinicBannerImage: ""
    });
    return
  }

  submitAvailability(event) {
    event.preventDefault();
    var state = this.state;
    state.clinicInfoFlag = true;
    
    //validation code
    if (state.clinicName) {
      if (state.clinicName.value.length > 0) {
        if (!validator.isValidName(state.clinicName.value)) {
          state.clinicName.isValid = false;
          state.clinicName.message = "Please enter a valid  clinic name";
        } else if (state.clinicName.value.length > 60) {
          state.clinicName.isValid = false;
          state.clinicName.message =
            "Max clinic name allowed size is 40 characters";
        } else {
          state.clinicName.isValid = true;
          state.clinicName.message = "";
        }
      } else {
        state.clinicName.isValid = false;
        state.clinicName.message = "Clinic name is Required";
      }
    }
    if (state.country) {
      if (state.country.value.length > 0) {
        if (!validator.isValidName(state.country.value)) {
          state.country.isValid = false;
          state.country.message = "Please enter a valid  country name";
        } else if (state.country.value.length > 60) {
          state.country.isValid = false;
          state.country.message =
            "Max country name allowed size is 40 characters";
        } else {
          state.country.isValid = true;
          state.country.message = "";
        }
      } else {
        state.country.isValid = false;
        state.country.message = "country name is Required";
      }
    }
    if (state.mobileNo) {
      if (state.mobileNo.value > 0) {
        if (!validator.isOnlyNumber(state.mobileNo.value)) {
          state.mobileNo.isValid = false;
          state.mobileNo.message = "Only numbers are allowed in Mobile number";
        } else if (validator.getPhoneNoLength(state.mobileNo.value) > 10) {
          state.mobileNo.isValid = false;
          state.mobileNo.message = "Max 10 digits are allowed in Mobile number";
        } else if (validator.getPhoneNoLength(state.mobileNo.value) < 9) {
          state.mobileNo.isValid = false;
          state.mobileNo.message = "Min 9 digits are allowed in Mobile number";
        } else if (state.phoneCode1.value == "") {
          state.phoneCode1.isValid = false;
          state.phoneCode1.message = "Please select Country Code";
          state.mobileNo.isValid = true;
          state.mobileNo.message = "";
        } else {
          state.mobileNo.isValid = true;
          state.mobileNo.message = "";
          state.phoneCode1.isValid = true;
          state.phoneCode1.message = "";
        }
      } else {
        state.mobileNo.isValid = false;
        state.mobileNo.message = "Mobile number is required";
      }
    }
    if (state.telephoneNo) {
      if (state.telephoneNo.value && state.telephoneNo.value.length > 0) {
        if (!validator.isOnlyNumber(state.telephoneNo.value)) {
          state.telephoneNo.isValid = false;
          state.telephoneNo.message =
            " Only numbers are allowed in mobile number";
        } else if (validator.getPhoneNoLength(state.telephoneNo.value) > 10) {
          state.telephoneNo.isValid = false;
          state.telephoneNo.message =
            " Max 10 digits are allowed in mobile number";
        } else if (validator.getPhoneNoLength(state.telephoneNo.value) < 9) {
          state.telephoneNo.isValid = false;
          state.telephoneNo.message =
            "Min 9 digits are allowed in mobile number";
        } else if (state.phoneCode2.value == "") {
          state.phoneCode2.isValid = false;
          state.phoneCode2.message = "Please select Country Code";
          state.telephoneNo.isValid = true;
          state.telephoneNo.message = "";
        } else {
          state.telephoneNo.isValid = true;
          state.telephoneNo.message = "";
          state.phoneCode2.isValid = true;
          state.phoneCode2.message = "";
        }
      }
    }
    if (state.phoneCode1) {
      if (state.phoneCode1.value == "") {
        state.phoneCode1.isValid = false;
        state.phoneCode1.message = "Please select Country Code";
      } else {
        state.phoneCode1.isValid = true;
        state.phoneCode1.message = "";
      }
    } else if (state.phoneCode2) {
      if (state.phoneCode2.value == "") {
        state.phoneCode2.isValid = false;
        state.phoneCode2.message = " Please select Country Code";
      } else {
        state.phoneCode2.isValid = true;
        state.phoneCode2.message = "";
      }
    }
    if (state.addressLineOne) {
      if (state.addressLineOne.value.length > 0) {
        if (state.addressLineOne.value.length > 70) {
          state.addressLineOne.isValid = false;
          state.addressLineOne.message = "Max allowed limit is 70 characters";
        } else {
          state.addressLineOne.isValid = true;
          state.addressLineOne.message = "";
        }
      } else {
        state.addressLineOne.isValid = false;
        state.addressLineOne.message = "Consultation address is required";
      }
    }
    if (state.city) {
      if (state.city.value.length > 0) {
        if (state.city.value.length > 30) {
          state.city.isValid = false;
          state.city.message = "Max allowed limit is 30 characters";
        } else {
          state.city.isValid = true;
          state.city.message = "";
        }
      } else {
        state.city.isValid = false;
        state.city.message = "City is required";
      }
    }
    if (state.fee) {
      if (state.fee.value > 0) {
        if (!validator.isOnlyNumber(state.fee.value)) {
          state.fee.isValid = false;
          state.fee.message = "Only numbers are allowed in Fee";
        } else if (validator.getPhoneNoLength(state.fee.value) > 10) {
          state.fee.isValid = false;
          state.fee.message = "Max 10 digits are allowed in Fee";
        } else if (state.currencySymbol.value == "") {
          state.currencySymbol.isValid = false;
          state.currencySymbol.message = "Currency symbol is required";
          state.fee.isValid = true;
          state.fee.message = "";
        } else {
          state.fee.isValid = true;
          state.fee.message = "";
          state.currencySymbol.isValid = true;
          state.currencySymbol.message = "";
        }
      } else {
        state.fee.isValid = false;
        state.fee.message = "Fee is required";
      }
    }
    if (state.currencySymbol) {
      if (state.currencySymbol.value == "") {
        state.currencySymbol.isValid = false;
        state.currencySymbol.message = "Currency symbol is required";
      } else {
        state.currencySymbol.isValid = true;
        state.currencySymbol.message = "";
      }
    }
    if (state.currencySymbol) {
      if (state.currencySymbol.value == "") {
        state.currencySymbol.isValid = false;
        state.currencySymbol.message = "Currency symbol is required";
      } else {
        state.currencySymbol.isValid = true;
        state.currencySymbol.message = "";
      }
    }
    if (
      state.monday ||
      state.tuesday ||
      state.wednesday ||
      state.thursday ||
      state.friday ||
      state.saturday ||
      state.sunday
    ) {
      if (
        state.monday.value == false &&
        state.tuesday.value == false &&
        state.wednesday.value == false &&
        state.thursday.value == false &&
        state.friday.value == false &&
        state.saturday.value == false &&
        state.sunday.value == false
      ) {
        state.friday.isValid = false;
        state.friday.message = "Select atleast one consultation day";
      } else {
        state.friday.isValid = true;
        state.friday.message = "";
      }
    }
    if (state.zipCode) {
      if (state.zipCode.value != "") {
        state.zipCode.isValid = true;
        state.zipCode.message = "";
      } else {
        state.zipCode.isValid = false;
        state.zipCode.message = "Zipcode is required";
      }
    }
    if (state.stateName) {
      if (
        (state.stateName.value != "" && state.stateName.value != undefined) ||
        document.getElementById("stateName").value != ""
      ) {
        if (!validator.isValidName(state.stateName.value)) {
          state.stateName.isValid = false;
          state.stateName.message = "Please enter a valid state";
          state.stateName.value = document.getElementById("stateName").value;
        } else if (state.stateName.value.length > 50) {
          state.stateName.isValid = false;
          state.stateName.message = "Max allowed limit is 50 characters";
        } else {
          state.stateName.isValid = true;
          state.stateName.message = "";
        }
      } else if (state.isValidZipcode == true) {
        state.stateName.isValid = true;
        state.stateName.message = "";
      } else {
        state.stateName.isValid = false;
        state.stateName.message = "State is required";
      }
    }

    if (state.zipCode) {
      if (state.zipCode.message == "Invalid zipcode") {
        state.zipCode.isValid = false;
        // state.zipCode.message = 'Invalid zipcode';
        state.zipCode.message = "";
        // state.zipcodeMatch = false;
      } else if (
        state.zipCode.value == "" &&
        state.zipCode.value == undefined
      ) {
        state.zipCode.isValid = false;
        state.zipCode.message = "Zipcode is required";
        state.zipcodeMatch = true;
      } else {
        state.zipCode.isValid = true;
        state.zipCode.message = "";
        // state.zipcodeMatch = state.zipcodeMatch;
      }
    }
    if (state.timezoner.value != "Select TimeZone") {
      state.timezoner.isValid = true;
      state.timezoner.message = "";
    } else {
      state.timezoner.isValid = false;
      state.timezoner.message = "TmieZone is required";
    }
    // checking time conflict Monday Morning

    if (this.state.monday.value) {
      if (this.state.mondayMorning.value) {
        console.log('here ',this.state.mondayMorning.value )
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
              console.log(this.state.timezoner.value)
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].mondayMorning
            ) {

              console.log('here 2')
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.mondayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.mondayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].mondayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].mondayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.mondayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
                  console.log(state.mondayMorningSchedule.message)
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.mondayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.mondayMorningSchedule.message != '') {
        // 	state.mondayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.mondayMorningSchedule.message = ''

        // }
      } else {
        state.mondayMorningSchedule.message = "";
      }

      //checking time conflict monday evening
      if (this.state.mondayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].mondayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.mondayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.mondayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].mondayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].mondayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.mondayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.mondayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.mondayEveningSchedule.message != '') {
        // 	state.mondayEveningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.mondayEveningSchedule.message = ''

        // }
      } else {
        state.mondayEveningSchedule.message = "";
      }

      if(!state.mondayMorning.value && !state.mondayEvening.value){
        console.log(state.mondayMorning.value ,state.mondayEvening.value)
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }
      
    } else {
      state.mondayEveningSchedule.message = "";
      state.mondayMorningSchedule.message = "";
    }
    if (this.state.tuesday.value) {
      // checking time conflict Tuesday Morning
      if (this.state.tuesdayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].tuesdayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.tuesdayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.tuesdayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].tuesdayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].tuesdayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.tuesdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.tuesdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.tuesdayMorningSchedule.message != '') {
        // 	state.tuesdayMorningSchedule.message ='The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.tuesdayMorningSchedule.message = ''

        // }
      } else {
        state.tuesdayMorningSchedule.message = "";
      }

      //checking time conflict Tuesday evening
      if (this.state.tuesdayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].tuesdayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.tuesdayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.tuesdayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].tuesdayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].tuesdayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.tuesdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.tuesdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.tuesdayEveningSchedule.message != '') {
        // 	state.tuesdayEveningSchedule.message ='The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.tuesdayEveningSchedule.message = ''

        // }
      } else {
        state.tuesdayEveningSchedule.message = "";
      }

      if(!state.tuesdayMorning.value && !state.tuesdayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }


    } else {
      state.tuesdayEveningSchedule.message = "";
      state.tuesdayMorningSchedule.message = "";
    }
    if (this.state.wednesday.value) {
      // checking time conflict wednesday Morning
      if (this.state.wednesdayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].wednesdayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.wednesdayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.wednesdayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].wednesdayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].wednesdayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.wednesdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.wednesdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.wednesdayMorningSchedule.message != '') {
        // 	state.wednesdayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.wednesdayMorningSchedule.message = ''

        // }
      } else {
        state.wednesdayMorningSchedule.message = "";
      }

      //checking time conflict wednesday evening
      if (this.state.wednesdayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].wednesdayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.wednesdayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.wednesdayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].wednesdayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].wednesdayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.wednesdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.wednesdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.wednesdayEveningSchedule.message != '') {
        // 	state.wednesdayEveningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.wednesdayEveningSchedule.message = ''

        // }
      } else {
        state.wednesdayEveningSchedule.message = "";
      }
      if(!state.wednesdayMorning.value && !state.wednesdayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }


    } else {
      state.wednesdayEveningSchedule.message = "";
      state.wednesdayMorningSchedule.message = "";
    }

    if (this.state.thursday.value) {
      // checking time conflict thursday Morning
      if (this.state.thursdayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].thursdayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.thursdayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.thursdayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].thursdayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].thursdayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.thursdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.thursdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.thursdayMorningSchedule.message != '') {
        // 	state.thursdayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.thursdayMorningSchedule.message = ''

        // }
      } else {
        state.thursdayMorningSchedule.message = "";
      }

      //checking time conflict thursday evening
      if (this.state.thursdayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].thursdayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.thursdayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.thursdayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].thursdayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].thursdayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.thursdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.thursdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.thursdayEveningSchedule.message != '') {
        // 	state.thursdayEveningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.thursdayEveningSchedule.message = ''

        // }
      } else {
        state.thursdayEveningSchedule.message = "";
      }

      if(!state.thursdayMorning.value && !state.thursdayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }

    } else {
      state.thursdayEveningSchedule.message = "";
      state.thursdayMorningSchedule.message = "";
    }

    if (this.state.friday.value) {
      // checking time conflict friday Morning
      if (this.state.fridayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].fridayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.fridayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.fridayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].fridayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].fridayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.fridayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.fridayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.fridayMorningSchedule.message != '') {
        // 	state.fridayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.fridayMorningSchedule.message = ''

        // }
      } else {
        state.fridayMorningSchedule.message = "";
      }

      //checking time conflict friday evening
      if (this.state.fridayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].fridayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.fridayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.fridayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].fridayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].fridayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.fridayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.fridayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.fridayEveningSchedule.message != '') {
        // 	state.fridayEveningSchedule.message ='The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.fridayEveningSchedule.message = ''

        // }
      } else {
        state.fridayEveningSchedule.message = "";
      }

      if(!state.fridayMorning.value && !state.fridayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }


    } else {
      state.fridayEveningSchedule.message = "";
      state.fridayMorningSchedule.message = "";
    }

    if (this.state.saturday.value) {
      // checking time conflict saturday Morning
      if (this.state.saturdayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].saturdayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.saturdayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.saturdayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].saturdayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].saturdayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.saturdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.saturdayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.saturdayMorningSchedule.message != '') {
        // 	state.saturdayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.saturdayMorningSchedule.message = ''

        // }
      } else {
        state.saturdayMorningSchedule.message = "";
      }

      //checking time conflict saturday evening
      if (this.state.saturdayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].saturdayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.saturdayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.saturdayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].saturdayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].saturdayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.saturdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.saturdayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.saturdayEveningSchedule.message != '') {
        // 	state.saturdayEveningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.saturdayEveningSchedule.message = ''

        // }
      } else {
        state.saturdayEveningSchedule.message = "";
      }

      if(!state.saturdayMorning.value && !state.saturdayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }
      

    } else {
      state.saturdayEveningSchedule.message = "";
      state.saturdayEveningSchedule.message = "";
    }
    if (this.state.sunday.value) {
      // checking time conflict sunday Morning
      if (this.state.sundayMorning.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].sundayMorning
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.sundayMorningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.sundayMorningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].sundayMornInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].sundayMornOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.sundayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";


                  console.log(state.sundayMorningSchedule.message)
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.sundayMorningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }

              // return
            }
          }
        }

        // if (state.sundayMorningSchedule.message != '') {
        // 	state.sundayMorningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.sundayMorningSchedule.message = ''

        // }
      } else {
        state.sundayMorningSchedule.message = "";
      }

      //checking time conflict sunday evening
      if (this.state.sundayEvening.value) {
        for (var i = 0; i < this.state.clinicInfo.length; i++) {
          if (i !== this.state.indexOfSelectedClinic) {
            // if (this.state.clinicName.value != this.state.clinicInfo[i].clinicName && this.state.timezoner.value == this.state.clinicInfo[i].contryzone) {
            if (
              this.state.timezoner.value ==
                this.state.clinicInfo[i].contryzone &&
              this.state.clinicInfo[i].sundayEvening
            ) {
              var format = "hh:mm:ss";

              // var time = moment() gives you current time. no format required.
              var intime = moment(
                this.state.sundayEveningSchedule.inTime,
                format
              );
              var outtime = moment(
                this.state.sundayEveningSchedule.outTime,
                format
              );

              var beforeTime = moment(
                this.state.clinicInfo[i].sundayEvenInTime,
                format
              );
              var afterTime = moment(
                this.state.clinicInfo[i].sundayEvenOutTime,
                format
              );
              var boolin = intime.isBetween(beforeTime, afterTime);
              var boolout = outtime.isBetween(beforeTime, afterTime);
              var outRangeIn = beforeTime.isBetween(intime, outtime);
              var outRangeOut = afterTime.isBetween(intime, outtime);
              if (
                boolin ||
                boolout ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.sundayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              } else if (
                outRangeIn ||
                outRangeOut ||
                intime._i == beforeTime._i ||
                outtime._i == afterTime._i
              ) {
                state.sundayEveningSchedule.message =
                  "The time you have selected is conflicting with " +
                  this.state.clinicInfo[i].clinicName +
                  " clinic";
              }
            }
          }
        }

        // if (state.sundayEveningSchedule.message != '') {
        // 	state.sundayEveningSchedule.message = 'The time you have selected is conflicting with ' + this.state.clinicInfo[i].clinicName + ' clinic'
        // } else {
        // 	state.sundayEveningSchedule.message = '';

        // }
      } else {
        state.sundayEveningSchedule.message = "";
      }
      if(!state.sundayMorning.value && !state.sundayEvening.value){
        state.friday.message = "Must choose atleast one timing from chosen day!";
      }

    } else {
      state.sundayEveningSchedule.message = "";
      state.sundayMorningSchedule.message = "";
    }
    state.showNotificationDiv = false;
    state.successMsg = "submit";

    this.setState(state);
    // return
    if (
      state.mondayMorningSchedule.message == "" &&
      state.mondayEveningSchedule.message == "" &&
      state.tuesdayMorningSchedule.message == "" &&
      state.tuesdayEveningSchedule.message == "" &&
      state.wednesdayMorningSchedule.message == "" &&
      state.wednesdayEveningSchedule.message == "" &&
      state.thursdayMorningSchedule.message == "" &&
      state.thursdayEveningSchedule.message == "" &&
      state.fridayMorningSchedule.message == "" &&
      state.fridayEveningSchedule.message == "" &&
      state.saturdayMorningSchedule.message == "" &&
      state.saturdayEveningSchedule.message == "" &&
      state.sundayMorningSchedule.message == "" &&
      state.sundayEveningSchedule.message == "" &&
      this.state.clinicName.value != "" &&
      this.state.mobileNo.value != "" &&
      this.state.phoneCode1.value != "" &&
      this.state.addressLineOne.value != "" &&
      this.state.city.value != "" &&
      this.state.fee.value != "" &&
      this.state.currencySymbol.value != "" &&
      (this.state.clinicName.message == "" ||
        this.state.clinicName.message == undefined) &&
      (this.state.mobileNo.message == "" ||
        this.state.mobileNo.message == undefined) &&
      (this.state.phoneCode1.message == "" ||
        this.state.phoneCode1.message == undefined) &&
      (this.state.addressLineOne.message == "" ||
        this.state.addressLineOne.message == undefined) &&
      (this.state.city.message == "" || this.state.city.message == undefined) &&
      (this.state.fee.message == "" || this.state.fee.message == undefined) &&
      (this.state.currencySymbol.message == "" ||
        this.state.currencySymbol.message == undefined) &&
      (this.state.phoneCode2.message == "" ||
        this.state.phoneCode2.message == undefined) &&
      (this.state.telephoneNo.message == "" ||
        this.state.telephoneNo.message == undefined) &&
      (this.state.country.message == "" ||
        this.state.country.message == undefined) &&
      (this.state.stateName.message == "" ||
        this.state.stateName.message == undefined) &&
      (this.state.friday.message == "" ||
        this.state.friday.message == undefined) &&
      (this.state.timezoner.message == "" ||
        this.state.timezoner.message == undefined)
    ) {
      if (this.state.latitude == 0 && this.state.longitude == 0) {
        this.geocoderZipcode(this.state.zipCode.value);
      } else {
        //
        var dateToday = moment(new Date()).format("YYYY-MM-DD");

        var scheduleObj = {
          userId: localStorage.getItem("userId"),
          specializationId: this.state.specialization.value,
          clinicName: this.state.clinicName.value,
          addressLineOne: this.state.addressLineOne.value,
          city: this.state.city.value,
          stateName: this.state.stateName.value,
          country: this.state.country.value,
          addressChange: this.state.addressChange,
          // countryId: this.state.country.id,
          // countryId: this.state.country.id != "" ? this.state.country.id : document.getElementById("country").value,
          fee: parseInt(this.state.fee.value),
          monday: this.state.monday.value,
          tuesday: this.state.tuesday.value,
          wednesday: this.state.wednesday.value,
          thursday: this.state.thursday.value,
          friday: this.state.friday.value,
          saturday: this.state.saturday.value,
          sunday: this.state.sunday.value,
          phoneCode1: this.state.phoneCode1.value
            ? this.state.phoneCode1.value
            : "",
          phoneCode2: this.state.phoneCode2.value
            ? this.state.phoneCode2.value
            : "",
          currencySymbol: this.state.currencySymbol.value,
          zipCode: this.state.zipCode.value,
          mobileNo: parseInt(this.state.mobileNo.value),
          telephoneNo: this.state.telephoneNo
            ? parseInt(this.state.telephoneNo.value)
            : 0,
          _id: this.state.availId,
          latitude: this.state.latitude,
          contryzone: this.state.timezoner.value,
          // latitude: lat,
          sundayMorning: this.state.sundayMorning.value,
          sundayEvening: this.state.sundayEvening.value,

          mondayMorning: this.state.mondayMorning.value,
          mondayEvening: this.state.mondayEvening.value,

          tuesdayMorning: this.state.tuesdayMorning.value,
          tuesdayEvening: this.state.tuesdayEvening.value,

          wednesdayMorning: this.state.wednesdayMorning.value,
          wednesdayEvening: this.state.wednesdayEvening.value,

          thursdayMorning: this.state.thursdayMorning.value,
          thursdayEvening: this.state.thursdayEvening.value,

          fridayMorning: this.state.fridayMorning.value,
          fridayEvening: this.state.fridayEvening.value,

          saturdayMorning: this.state.saturdayMorning.value,
          saturdayEvening: this.state.saturdayEvening.value,

          sundayMorningSchedule: this.state.sundayMorningSchedule,
          sundayEveningSchedule: this.state.sundayEveningSchedule,
          saturdayMorningSchedule: this.state.saturdayMorningSchedule,
          saturdayEveningSchedule: this.state.saturdayEveningSchedule,

          mondayMorningSchedule: this.state.mondayMorningSchedule,
          mondayEveningSchedule: this.state.mondayEveningSchedule,
          tuesdayMorningSchedule: this.state.tuesdayMorningSchedule,
          tuesdayEveningSchedule: this.state.tuesdayEveningSchedule,

          wednesdayMorningSchedule: this.state.wednesdayMorningSchedule,
          wednesdayEveningSchedule: this.state.wednesdayEveningSchedule,
          thursdayMorningSchedule: this.state.thursdayMorningSchedule,
          thursdayEveningSchedule: this.state.thursdayEveningSchedule,

          fridayMorningSchedule: this.state.fridayMorningSchedule,
          fridayEveningSchedule: this.state.fridayEveningSchedule,

          longitude: this.state.longitude,
          isPrimary: this.state.isPrimary.value,
          TodayDate: dateToday,
          isVettingTriggered: this.state.isVettingTriggered,
          clinicBannerObj: this.state.clinicImageObj, //ClinicBannerImage
        };

        var userObj = {
          userId: localStorage.getItem("userId"),
        };
        var experienceObj = {
          size: 20,
        };
        // return
        this.props.actions.saveAvailability(scheduleObj,{editClinic: this.state.editClinic && this.state.editClinic, clinicBannerImageDeleted: this.state.clinicBannerImageDeleted});
        if(this.state.editClinic === true){
          state.editClinic = false
        }
        var state = this.state;
        state.consultationErrMsg = "";
        // var state = this.state;
        state.clinicBannerImageDeleted = false,
        state.mondayMorningSchedule.message = "";
        state.mondayEveningSchedule.message = "";
        state.tuesdayMorningSchedule.message = "";
        state.tuesdayEveningSchedule.message = "";
        state.wednesdayMorningSchedule.message = "";
        state.wednesdayEveningSchedule.message = "";
        state.thursdayMorningSchedule.message = "";
        state.thursdayEveningSchedule.message = "";
        state.fridayMorningSchedule.message = "";
        state.fridayEveningSchedule.message = "";
        state.saturdayMorningSchedule.message = "";
        state.saturdayEveningSchedule.message = "";
        state.sundayMorningSchedule.message = "";
        state.sundayEveningSchedule.message = "";
        state.mondayMorning.value = true;
        state.mondayEvening.value = true;
        state.tuesdayMorning.value = true;
        state.tuesdayEvening.value = true;
        state.wednesdayMorning.value = true;
        state.wednesdayEvening.value = true;
        state.thursdayMorning.value = true;
        state.thursdayEvening.value = true;
        state.fridayMorning.value = true;
        state.fridayEvening.value = true;
        state.saturdayMorning.value = true;
        state.saturdayEvening.value = true;
        state.sundayMorning.value = true;
        state.sundayEvening.value = true;
        state.firstRun = true,
        this.setState(state);
        this.resetAvailabilityForm();
      }
    }
  }

  toggle() {
    var windowWidth = $(window).width();
    if (windowWidth < 768) {
      $("body").toggleClass("sidebar-open");
    } else {
      $("body").toggleClass("sidebar-collapse");
    }
  }

  resetAvailabilityForm() {
    var state = this.state;
    state.editClinic = false;
    state.Address = {value: "", isValid: true, message: "" };
    state.clinicName = { value: "", isValid: true, message: "" };
    state.addressLineOne = { value: "", isValid: true, message: "" };
    state.sunday = { value: false, isValid: true, message: "" };
    state.saturday = { value: false, isValid: true, message: "" };
    state.timezoner = { value: "Select TimeZone", isValid: true, message: "" };
    state.clinicBannerObj = null;
    state.clinicBannerImage = null;
    state.tempUpClinicBanner = "";
    state.Address.value = "";
    state.tempBannerImage = "";
  
    state.monday = {
      value: false,
      isValid: true,
      message: "",
    };
    state.tuesday = { value: false, isValid: true, message: "" };
    state.wednesday = { value: false, isValid: true, message: "" };
    state.thursday = { value: false, isValid: true, message: "" };
    state.friday = { value: false, isValid: true, message: "" };
    // state.morningSchedule = { inTime: '00:00', outTime: '11:30', startHour: 15, startMinute: 10, endHour: 5, endMinute: 10, isValid: true, message: '' };
    // state.eveningSchedule = { inTime: '12:00', outTime: '23:30', startHour: 15, startMinute: 10, endHour: 5, endMinute: 10, isValid: true, message: '' };
    (state.countryList = []),
      (state.country = { value: "", id: "", isValid: true, message: "" });
    (state.stateList = []),
      (state.stateName = { value: "", id: "", isValid: true, message: "" });
    state.phoneCode1 = { value: "", isValid: true, message: "" };
    (state.phoneCodeList = constant.PHONENOCOUNTRYCODE),
      (state.phoneCode2 = { value: "", isValid: true, message: "" });
    (state.currencyList = constant.CURRENCY),
      (state.currencySymbol = { value: "", isValid: true, message: "" });
    state.fee = { value: "", isValid: true, message: "" };
    state.city = { value: "", isValid: true, message: "" };
    state.zipCode = { value: "", isValid: true, message: "" };
    state.mobileNo = { value: "", isValid: true, message: "" };
    state.telephoneNo = { value: "", isValid: true, message: "" };
    state.isValidZipcode = false;
    state.modalIsOpen = false;
    state.country.value = "";
    state.stateName.value = "";
    state.latitude = 0;
    state.longitude = 0;
    state.availId = "";
    if(state.clinicInfo.length === 0){

      state.isPrimary.value = "true";
    }
    else{
      state.isPrimary.value = "false"
    }
    state.firstRun = true;
    state.zipcodeMatch = true;

    this.setState(state);
  }
  async componentWillMount() {
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    if (user.isVerified == 2) {
      this.setState({
        isDisable: true,
      });
    }
    let experienceObj = {
      size: 20,
    };
    let obj = {
      userId: localStorage.getItem("userId"),
    };
    await this.props.actions.getSpecialistProfileData(obj);
    await this.props.actions.getSpecializationList();
    await this.props.actions.getConditionalProcedureMappingList();

    await this.props.actions.getExperienceList(experienceObj);
    await this.props.actions.getAvailabilitySlot(obj);
    await this.props.actions.getCountriesList();
    var state = this.state;
    state.firstRun = true
    this.setState(state)
    return
  }

  componentDidMount() {}

  async componentWillReceiveProps(nextProps) {
    console.log(nextProps)
    var state = this.state;

    if (state.isDirty == false && state.totalErrors == false && state.editEnabled == false) {

      if (
        nextProps &&
        nextProps.specialistInfo &&
        nextProps.specialistInfo.academics &&
        nextProps.specialistInfo.qualification
      ) {
        
        let EduSummary = [];

        for (let i = 0; i < nextProps.specialistInfo.academics.length; i++) {
          let obj = {
            academics: nextProps.specialistInfo.academics[i],
            qualifications: nextProps.specialistInfo.qualification[i],
            academicsMessage: "",
            qualificationsMessage: "",
            isValidAcademics: true,
            isValidQualifications: true,
          };
          EduSummary.push(obj);
        }

     
        if(state.EduSummary!== null || state.EduSummary !== ""){

          state.EduSummary = EduSummary;
          state.firstRun = false;
        }
      }
      let Awards = [];
      if (
        nextProps &&
        nextProps.specialistInfo &&
        nextProps.specialistInfo.professionalAward
      ) {
        
        for (
          let i = 0;
          i < nextProps.specialistInfo.professionalAward.length;
          i++
        ) {
          let obj = {
            value: nextProps.specialistInfo.professionalAward[i],
            message: "",
          };
          Awards.push(obj);
        }
    
          state.Awards = Awards
        
      }
        if(nextProps.specialistInfo.languages){
          state.selectedLanguagesValues = nextProps.specialistInfo.languages
        }

        var tempCond = [];
        if (
          nextProps.specialistInfo &&
          nextProps.specialistInfo.conditionProcedure
        ) {
          for (
            let i = 0;
            i < nextProps.specialistInfo.conditionProcedure.length;
            i++
          ) {
            let obj = {
              label:
                nextProps.specialistInfo.conditionProcedure[i].conditionName,
              value: nextProps.specialistInfo.conditionProcedure[i]._id,
            };
            tempCond.push(obj);
          }
          
            state.conditionProcedure = tempCond
          
        }


        if (
          nextProps.experienceList != undefined &&
          nextProps.experienceList.month
        ) {
          state.experienceList = nextProps.experienceList
            ? nextProps.experienceList
            : state.experienceList;
        }
        if (nextProps.specializationList != undefined) {
          state.specializationList = nextProps.specializationList
            ? nextProps.specializationList
            : state.specializationList;
        }

        if (nextProps.conditionalProcedureMappingList != undefined) {
          state.conditionalProcedureMappingList = nextProps.conditionalProcedureMappingList
            ? nextProps.conditionalProcedureMappingList
            : state.conditionalProcedureMappingList;
        }
        if (nextProps.specialistInfo.subspecializationData != undefined) {
          state.subSpecializationList = nextProps.specialistInfo
            .subspecializationData
            ? nextProps.specialistInfo.subspecializationData
            : "";
        }
        if (nextProps.countryList != undefined) {
          (state.countryList = nextProps.countryList),
            (state.stateList = nextProps.stateList);
        }

       
       
          
          function capital_letter(str) 
          {
            str = str.split(" ");
            
            for (var i = 0, x = str.length; i < x; i++) {
             str[i] = str[i][0].toUpperCase() + str[i].substr(1);
            }
            
            return str.join(" ");
          }
        
          if(nextProps.clinicInfo){
            state.clinicInfo =
            nextProps.clinicInfo && nextProps.clinicInfo.length > 0
              ? nextProps.clinicInfo
              : state.clinicInfo;
          }

        //specialist Information
   


        // if (state.isNotReset && state.editButton) {
          (state.userName = {
            value:
            nextProps.specialistInfo.userName
                ? nextProps.specialistInfo.userName && capital_letter(nextProps.specialistInfo.userName)
                : state.userName.value,
            isValid: true,
            message: state.userName.message && state.userName.message,
          }),
            // (state.phoneNo = {
            //   value: nextProps.specialistInfo.phoneNo
            //     ? nextProps.specialistInfo.phoneNo
            //     : this.state.phoneNo.value,
            //   isValid: true,
            //   message: "",
            // }),
            (state.gender = {
              value: 
              nextProps.specialistInfo.gender
              ? nextProps.specialistInfo.gender
              :  state.gender.value,
              isValid: true,
              message: "",
            }),
            (state.email = {
              value: nextProps.specialistInfo.email,
              isValid: true,
              message: "",
            });
          if (
            nextProps.specialistInfo.image != "" &&
            nextProps.specialistInfo.image != undefined
          ) {
            state.imageCopy = nextProps.specialistInfo.tempProfileImage
              ? nextProps.specialistInfo.tempProfileImage
              : "";
          } // state.gender.value == 'male' ?  'doctor_m.png' : 'doctor_f.png'
          (state.yearExperience = {
            value: nextProps.specialistInfo.yearExperience
              ? nextProps.specialistInfo.yearExperience
              : state.yearExperience.value,
            isValid: true,
            message: "",
          }),
            (state.registrationNo = {
              value: nextProps.specialistInfo.registrationNo
                ? nextProps.specialistInfo.registrationNo
                : state.registrationNo.value,
              isValid: true,
              message: state.registrationNo.message ? state.registrationNo.message : "",
            }),
            (state.profileSummary = {
              value: nextProps.specialistInfo.profileSummary
                
                ? nextProps.specialistInfo.profileSummary
                : this.state.profileSummary.value,
              isValid: true,
              message: state.profileSummary.message? state.profileSummary.message: "",
            }),

            (state.monthExperience = {
              value: nextProps.specialistInfo.monthExperience
                ? nextProps.specialistInfo.monthExperience
                : state.monthExperience.value,
              isValid: true,
              message: state.profileSummary.message ? state.profileSummary.message: "",
            }),
            (state.phoneNoCountryCode = {
              value: nextProps.specialistInfo.phoneNoCountryCode
                ? nextProps.specialistInfo.phoneNoCountryCode
                : state.phoneNoCountryCode.value,
            }),
            (state.consultationErrMsg =
              state.clinicInfo && state.clinicInfo.length > 0
                ? ""
                : state.consultationErrMsg),
            (state.clinicInfoErr =
              state.clinicInfo && state.clinicInfo.length > 0
                ? ""
                : state.clinicInfoErr),
            (state.subSpecialization = {
              value:
            nextProps.specialistInfo.subspecializationData
                 
                  ? nextProps.specialistInfo.subspecializationData 
                  : state.subSpecialization.value,
                 
              isValid: true,
              message: state.subSpecialization.message? state.subSpecialization.message : "",
            });
        // }

        // state.country = { value: '', id: '', isValid: true, message: '' }

        (state.sundayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.sundayMornETValid = {
            start:
              state.sundayMornETValid && state.sundayMornETValid != ""
                ? state.sundayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.sundayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.sundayEvenETValid = {
            start:
              state.sundayEvenETValid && state.sundayEvenETValid != ""
                ? state.sundayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        (state.mondayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.mondayMornETValid = {
            start:
              state.mondayMornETValid && state.mondayMornETValid != ""
                ? state.mondayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.mondayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.mondayEvenETValid = {
            start:
              state.mondayEvenETValid && state.mondayEvenETValid != ""
                ? state.mondayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        (state.tuesdayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.tuesdayMornETValid = {
            start:
              state.tuesdayMornETValid && state.tuesdayMornETValid != ""
                ? state.tuesdayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.tuesdayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.tuesdayEvenETValid = {
            start:
              state.tuesdayEvenETValid && state.tuesdayEvenETValid != ""
                ? state.tuesdayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        (state.wednesdayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.wednesdayMornETValid = {
            start:
              state.wednesdayMornETValid && state.wednesdayMornETValid != ""
                ? state.wednesdayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.wednesdayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.wednesdayEvenETValid = {
            start:
              state.wednesdayEvenETValid && state.wednesdayEvenETValid != ""
                ? state.wednesdayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        (state.thursdayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.thursdayMornETValid = {
            start:
              state.thursdayMornETValid && state.thursdayMornETValid != ""
                ? state.thursdayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.thursdayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.thursdayEvenETValid = {
            start:
              state.thursdayEvenETValid && state.thursdayEvenETValid != ""
                ? state.thursdayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        (state.saturdayMornSTValid = {
          start: constant.MORNING_START.START,
          end: constant.MORNING_START.END,
        }),
          (state.saturdayMornETValid = {
            start:
              state.saturdayMornETValid && state.saturdayMornETValid != ""
                ? state.saturdayMornETValid.start
                : constant.MORNING_END.START,
            end: constant.MORNING_END.END,
          });
        (state.saturdayEvenSTValid = {
          start: constant.EVENING_START.START,
          end: constant.EVENING_START.END,
        }),
          (state.saturdayEvenETValid = {
            start:
              state.saturdayEvenETValid && state.saturdayEvenETValid != ""
                ? state.saturdayEvenETValid.start
                : constant.EVENING_END.START,
            end: constant.EVENING_END.END,
          });

        // this.setState(state);

        if (
          this.state.stateErrorCode == 200 &&
          nextProps.zipcodeInfo &&
          nextProps.zipcodeInfo.code == 200 &&
          state.zipCode.value != "" &&
          state.zipCode.value != undefined
        ) {
          state.country.value = nextProps.zipcodeInfo.country;
          state.stateName.value = nextProps.zipcodeInfo.stateName;
          state.latitude = nextProps.zipcodeInfo.latitude;
          state.longitude = nextProps.zipcodeInfo.longitude;
          state.stateList = nextProps.zipcodeInfo.stateList;
          state.country.message = "";
          state.stateName.message = "";
          state.city.value = nextProps.zipcodeInfo.city;
          state.addressLineOne.value = nextProps.zipcodeInfo.addressLineOne;
          state.addressLineOne.message = "";
          state.city.message = "";
          state.zipcodeMatch = true;
        } else if (
          this.state.stateErrorCode == 200 &&
          nextProps.zipcodeInfo &&
          nextProps.zipcodeInfo.code == 400 &&
          state.zipCode.value != "" &&
          state.zipCode.value != undefined
        ) {
          state.zipCode.message = "";
          state.zipcodeMatch = false;

          state.latitude = 0;
          state.longitude = 0;

          this.setState({ state });
        }

        if (
          nextProps.specialistInfo &&
          nextProps.specialistInfo.specialization
        ) {
          state.specialization = {
            value:
            nextProps.specialistInfo.specialization
                ? nextProps.specialistInfo.specialization
                : state.specialization.value,
            isValid: true,
            message: "",
          };
        }

        this.setState({ state });

    
        if (
          this.state.specialization.value != "" &&
          this.state.specialization.value != undefined &&
          this.state.subSpecializationList.length == 0 &&
          state.isOnloadSpecialization == true
        ) {
          state.isOnloadSpecialization = false;
          this.setState({ state });
          let specializationObj = {
            specializationId: this.state.specialization.value,
          };
        }

        if (
          this.state.experienceList &&
          !this.state.experienceList.hasOwnProperty("year")
        ) {
          let experienceObj = {
            size: 20,
          };
          await this.props.actions.getExperienceList(experienceObj);
          
        }

        if( !(nextProps.specialistInfo && nextProps.specialistInfo.userId)){
          let obj = {
            userId: localStorage.getItem("userId"),
          };
          await this.props.actions.getSpecialistProfileData(obj)
          
        }



        if (
          this.state.specializationList &&
          this.state.specializationList.length == 0
        ) {
          await this.props.actions.getSpecializationList();
        }

        if (
          this.state.conditionalProcedureMappingList &&
          this.state.conditionalProcedureMappingList.length == 0
        ) {
          await this.props.actions.getConditionalProcedureMappingList();
        }

        if (
          this.state.clinicInfo &&
          this.state.clinicInfo.length == 0 &&
          state.clinicInfoFlag
        ) {
          let obj = {
            userId: localStorage.getItem("userId"),
          };
          await this.props.actions.getAvailabilitySlot(obj);
          if (nextProps.clinicInfo && nextProps.clinicInfo.length == 0) {
            this.setState({ clinicInfoFlag: false });
          }
        }

        
    }

    if(nextProps.clinicInfo){
      state.clinicInfo =
      nextProps.clinicInfo && nextProps.clinicInfo.length > 0
        ? nextProps.clinicInfo
        : state.clinicInfo;
    }
    return
  }



  deleteImage() {
    if (this.state.removeProfileImageDialog === true) {
    
      this.setState({
        tempUploadedImage: "",
        tempImageObj: "",
        imageToBeDeleted: true,
        imagePreviewUrl: "deleted",
        isDirty: true
      },()=>{
        console.log(this.state.tempUploadedImage, this.state.tempImageObj, this.state.imageCopy)
      });
      toast.info("Image Removed");

      this.handleClose();
      this.handleClose2();
    } else {
      this.setState({ removeProfileImageDialog: true });
    }
  }
  saveSpecialistProfile() {
    var state = this.state;
    state.clinicInfoFlag = false;
    state.editButton = true;

    let tempQualifications = [];
    let tempAcademics = [];
    let eduSummaryError = false;
    let tempEduSummary = this.state.EduSummary;


    if (this.state.EduSummary) {
      for (let i = 0; i < this.state.EduSummary.length; i++) {
        let {
          academics,
          qualifications,
          isValidAcademics,
          isValidQualifications,
        } = this.state.EduSummary[i];

        if (!academics) {
          tempEduSummary[i].isValidAcademics = false;
          tempEduSummary[i].academicsMessage =
            "Enter educational institution where degree was awarded(required)";
          eduSummaryError = true;
        } else {
          tempEduSummary[i].isValidAcademics = true;
          tempEduSummary[i].academicsMessage = "";
          tempAcademics.push(academics);
        }
        if (!qualifications) {
          tempEduSummary[i].isValidQualifications = false;
          tempEduSummary[i].qualificationsMessage =
            "Enter professional degrees,diplomas or certifications(required)";
          eduSummaryError = true;
        } else {
          tempEduSummary[i].isValidQualifications = true;
          tempEduSummary[i].qualificationsMessage = "";
          tempQualifications.push(qualifications);
        }
      }
    }


    if (tempEduSummary.length < 1) {
      eduSummaryError = true;
    }

    else{
      eduSummaryError = false;
    }

    this.setState({ EduSummary: tempEduSummary });

    let awards = [];
    let awardsError = false;

    if (this.state.Awards) {
      for (let i = 0; i < this.state.Awards.length; i++) {
        let { value, message } = this.state.Awards[i];

        let tempObj = this.state.Awards[i];

        if (!value) {
          tempObj.message =
            "Example: Professional Associations,Awards,Recognitions,etc.(required)";
          awardsError = true;
        } else {
          tempObj.message = "";
        }

        awards.push(tempObj);
      }
    }
    if (awards.length < 1) {
      awardsError = true;
      console.log(awards.length)
    }
    else{
      awardsError = false
    }
    this.setState({ Awards: awards });

    if (this.state.selectedLanguagesValues && this.state.selectedLanguagesValues.length == 0) {
      state.languageError.error = true;
      state.languageError.message = "Please provide at least one Language";
    }
    if (state.userName) {
      if (state.userName.value.length > 0) {
        if (!validator.isValidName(state.userName.value)) {
          state.userName.isValid = false;
          state.userName.message = "Please enter a valid name";
        } else {
          state.userName.isValid = true;
          state.userName.message = "";
        }
      } else {
        state.userName.isValid = false;
        state.userName.message = "Name is Required";
      }
    }
    if (state.profileSummary) {
      if (state.profileSummary.value.length > 0) {
        if (state.profileSummary.value.length > 2000) {
          state.profileSummary.isValid = false;
          state.profileSummary.message = "Character count exceeded";
        } else {
          state.profileSummary.isValid = true;
          state.profileSummary.message = "";
        }
      } else {
        state.profileSummary.isValid = false;
        state.profileSummary.message = "Profile summary is Required";
      }
    }

    if (state.registrationNo) {
      if (state.registrationNo.value && state.registrationNo.value != "") {
        if (!validator.isOnlyAlphaNumeric(state.registrationNo.value)) {
          state.registrationNo.isValid = false;
          state.registrationNo.message =
            "Only alpha numeric characters are allowed in registration number";
          this.setState(state);
        } else {
          state.registrationNo.isValid = true;
          state.registrationNo.message = "";
        }
      } else {
        state.registrationNo.isValid = false;
        state.registrationNo.message = "Registration number is required";
      }
    }


    if (state.clinicInfo && state.clinicInfo.length == 0) {
      state.clinicInfoErr = "Atleast add 1 consultation address";
    }

    if (state.specialization) {
      if (
        state.specialization.value == "" ||
        state.specialization.value == undefined
      ) {
        state.specialization.isValid = false;
        state.specialization.message = "Specialization is required";
      } else {
        state.specialization.isValid = true;
        state.specialization.message = "";
        state.consultationErrMsg = "";
      }
    }
    if (state.subSpecialization) {
      if (
        state.subSpecialization.value &&
        state.subSpecialization.value != ""
      ) {
        if (!validator.isOnlyAlphaNComma(state.subSpecialization.value)) {
          state.subSpecialization.isValid = false;
          state.subSpecialization.message =
            "Only alphabets & comma are allowed in Sub Speciality";
          this.setState(state);
        } else {
          state.subSpecialization.isValid = true;
          state.subSpecialization.message = "";
        }
      } else {
        state.subSpecialization.isValid = false;
        state.subSpecialization.message = "Atleast add one Sub Speciality";
      }
    }

    this.setState(state);
    console.log(!eduSummaryError,!awardsError,this.state.conditionProcedure,this.state.selectedLanguagesValues.length)
    
    if(state.conditionProcedure && state.conditionProcedure.length == 0 && state.noConditionProcedure == false){
      state.conditionProcedureMsg = "Please choose atleast one condition."
    }
    
    else{
      state.conditionProcedureMsg = ""
    }






    if (
      !this.state.languageError.error &&
      this.state.userName.value != "" &&
      this.state.registrationNo.value != "" &&
      this.state.subSpecialization.value != "" &&
      this.state.specialization.value != "" &&
      this.state.clinicInfo.length != 0 &&
      this.state.consultationErrMsg == "" &&
      (this.state.specialization.message == "" ||
        this.state.specialization.message == undefined) &&
      (this.state.userName.message == "" ||
        this.state.userName.message == undefined) &&
        ((this.state.conditionProcedure &&
      this.state.conditionProcedure.length !== 0) || this.state.noConditionProcedure) &&
      this.state.selectedLanguagesValues.length !== 0 &&
      (this.state.registrationNo.message == "" ||
        this.state.registrationNo.message == undefined) &&
      (awardsError==false) &&
      (eduSummaryError==false) &&
      (this.state.selectedLanguagesValues!==null ||
      this.state.selectedLanguagesValues!==[]) &&
      (this.state.subSpecialization.message == "" ||
        this.state.subSpecialization.message == undefined) &&
      (this.state.profileSummary.message == "" ||
        this.state.profileSummary.message == undefined)
    ) {
      console.log('here')


      let totalSpecialistLanguage = [];
      if (
        this.state.selectedLanguagesValues &&
        this.state.selectedLanguagesValues.length !== 0
      ) {
        totalSpecialistLanguage = this.state.selectedLanguagesValues.map(
          (item) => {
            return item;
          }
        );
      }

      let totalProcedures = [];
      let condProcError = false;

      if (
        this.state.conditionProcedure &&
        this.state.conditionProcedure.length !== 0
      ) {
        totalProcedures = this.state.conditionProcedure.map((item) => {
          // console.log(item);
          return item.value;
        });
      }

      console.log(totalProcedures, this.state.conditionProcedure);

      let profAward = [];
      if (this.state.Awards && this.state.Awards.length !== 0) {
        profAward = this.state.Awards.map((item) => {
          return item.value;
        });
      }

      var profileObj = {
        userName: this.state.userName.value,
      
        gender: this.state.gender.value,
        email: this.state.email.value,
        image: this.state.imageCopy,
        userId: localStorage.getItem("userId"),
        yearExperience: this.state.yearExperience.value
          ? parseInt(this.state.yearExperience.value)
          : 0,
        specialization: this.state.specialization.value,
        registrationNo: this.state.registrationNo.value,
        qualification: tempQualifications,
        monthExperience: this.state.monthExperience.value
          ? parseInt(this.state.monthExperience.value)
          : 0,
        subSpecialization: this.state.subSpecialization.value,
        profileSummary: this.state.profileSummary.value,
        academics: tempAcademics,
        professionalAward: profAward,
        isEdited: this.state.isDisable == true ? false : true,
        languages: totalSpecialistLanguage,
        isVettingTriggered: this.state.isVettingTriggered
          ? this.state.isVettingTriggered
          : false,
        conditionProcedure: totalProcedures,
      };

      console.log("object to be saved", profileObj);

      this.props.actions.saveSpecialistProfile(profileObj,this.props)
   

      if (this.state.tempUploadedImage) {
       
        this.submitUploadedSpecialistImg();
      }

      if (this.state.imageToBeDeleted) {
        
        var user = localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user"))
          : {};
        var delImage = {
          userId: user._id,
          userType: "Specialist",
        };

        if (
          !this.state.defaultImageURL.endsWith("_m.png") &&
          !this.state.defaultImageURL.endsWith("_f.png")
        ) {
          this.props.actions.deleteImageProfile(delImage);
          this.setState({imageCopy:"noUserImage.jpg"})
        }
      }

      this.setState({
        isDisablePI: true,
        isDisablePB: true,
        isDisableAM: true,
        isDisableES: true,
        isDisablePS: true,
        isDirty: false,
        editEnabled:false,
        tempImageObj: "",
        totalErrors: false,
        tempUploadedImage: "",
        imageToBeDeleted: false,
        // imagePreviewUrl: "",
      });


    } else {
      this.setState({
        totalErrors: true,
      });
    }
  }

  async deleteAvailability(){
    if(this.state.clinicToBeDeletedId){
      let delObj = {
        availabilityId: this.state.clinicToBeDeletedId,
      };
      await this.props.actions.deleteAvailability(delObj);
      this.setState({
        clinicToBeDeletedId: null,
        deleteClinicDialog: false
      })
    }
   
  }

   async deleteAvailabilityDialog(id, isPrimary) {
    var state = this.state;
    state.clinicInfoFlag = true;
    await console.log('hello')
    this.setState(state);
    if (!isPrimary) {
        this.setState({
          clinicToBeDeletedId: id,
          deleteClinicDialog: true
        })



    } else {
  

      this.setState({
        clinicToBeDeletedId: null,
        deleteClinicDialog: false,
        chooseAnotherClinicDialog:true,
      })
    }
  }
  onLogoutclick(data) {
    if (this.state.logoutButton == false) {
      this.setState({
        logoutButton: true,
      });
    } else {
      this.setState({
        logoutButton: false,
      });
    }
  }
  // editProfile() {
  //   // debugger;
  //   this.setState(
  //     {
  //       editButton: false,
  //     },
  //     () => {
  //       confirmAlert({
  //         customUI: ({ onClose }) => {
  //           return (
  //             <div className="custom-ui disclaimer_appointement">
  //               <a
  //                 style={{ cursor: "pointer" }}
  //                 className="closeBtn"
  //                 onClick={onClose}
  //               ></a>

  //               <h1>Disclaimer</h1>
  //               <span>
  //                 Modifying the Profile will trigger the Vetting Process. You
  //                 will be taken offline from Specialist listing until the
  //                 verification is complete.
  //               </span>
  //               <div className="bottomBtn text-center">
  //                 <button
  //                   type="button"
  //                   onClick={() => {
  //                     this.setState({
  //                       isDisable: false,
  //                     });
  //                     onClose();
  //                   }}
  //                   className="btn btn-warning btn-lg"
  //                 >
  //                   Ok
  //                 </button>
  //               </div>
  //             </div>
  //           );
  //         },
  //       });
  //     }
  //   );
  // }

  onSelect(event) {
    const { value, checked } = event.target;

    if (checked) {
      let languages = [...this.state.languages];
      var indexOfL = languages.findIndex((l) => l == value);
      if (indexOfL < 0) {
        let languages = [...this.state.languages, value];
        this.setState({ languages, languageError: { error: false } }, () => {});
      }
    } else {
      let languages = [...this.state.languages];
      // let indexOfL = languages.indexOf(removedItem.name);
      var indexOfL = languages.findIndex((l) => l == value);
      languages.splice(indexOfL, 1);
      this.setState({ languages }, () => {
        if (this.state.languages.length == 0)
          this.setState({
            languageError: {
              error: true,
              message: "Please provide at least one Language",
            },
          });
      });
    }
    //
  }

  onRemove(selectedList, removedItem) {
    let languages = [...this.state.languages];
    // let indexOfL = languages.indexOf(removedItem.name);
    var indexOfL = languages.findIndex((l) => l.name == removedItem.name);
    languages.splice(indexOfL, 1);
    this.setState({ languages }, () => {
      if (this.state.languages.length == 0)
        this.setState({
          languageError: {
            error: true,
            message: "Please provide at least one Language",
          },
        });
    });
  }

  changeInMobileNumber = (mobileNumber) => {
    if (mobileNumber != undefined) {
      let mobileNumberOnly = mobileNumber.substr(mobileNumber.length - 10);
      let phoneCode1 = mobileNumber.substring(0, mobileNumber.length - 10);
      // this.setState({  })
    }
  };

  onChangeLanguage = (selectedValue) => {
    this.setState({
      isDirty: true
    })
    console.log(selectedValue, this.state.selectedLanguagesValues);
    const { selectedLanguagesValues } = this.state;
    console.log("onChange", selectedValue);
    if (selectedValue != null) {
      if (selectedValue && selectedValue.length <= 3) {
        this.setState({ selectedLanguagesValues: selectedValue });
        this.setState({ languageError: { error: false } });
      } else if (
        selectedLanguagesValues &&
        selectedLanguagesValues.length === 3
      ) {
        this.setState({
          languageError: {
            error: true,
            message: "You cannot choose more than 3 languages",
          },
        });
      }
    }

    if (selectedValue && selectedValue.length === 0) {
      this.setState({
        selectedLanguagesValues: selectedValue,
        languageError: {
          error: true,
          message: "Please provide at least one Language",
        },
      });
    }

    if (selectedValue === null) {
      this.setState({
        selectedLanguagesValues: selectedValue,
      });
    }
  };

  handleClickOpen = () => {
    this.setState({ viewProPicUploadDialog: true });
  };

  handleClose = () => {
    this.setState({ viewProPicUploadDialog: false, tempImageObj: null });
  };

  handleClose2 = () => {
    this.setState({ removeProfileImageDialog: false });
  };

  handleClose3 = () =>{
    this.setState({deleteClinicDialog: false,
      chooseAnotherClinicDialog: false});
  }

  handleClose4 = () => {
    var state = this.state
    state.designatePrimaryDialog = false
    this.setState(state)
   
  }

  designatePrimaryNot = (event) =>{
    var state = this.state
    state.isPrimary.value = "false"
    state.designatePrimaryDialog = false
    this.setState(state)
  }

  designatePrimary = (event) =>{
    var state = this.state
    console.log(this.state.isPrimary)
    state.isPrimary.value = "true"
    state.designatePrimaryDialog = false
    this.setState(state,()=>{
      console.log(this.state.isPrimary.value)
    })
  }

  onChangeConditionProcedure = (event, value) => {
    console.log(value)
    // debugger
    let conditionProcedure = value;
    let conditionProcedureMsg = ""
    let state = this.state
    state.conditionProcedure = []
    if(value !== [] && value !== null && value !== undefined){
      state.conditionProcedure = value
    }
 
    state.conditionProcedureMsg = ""
    this.setState({ state });
  };

  handleChange = (event) => {
    if (this.state.selectedLanguagesValues.length < 3) {
      this.setState({
        selectedLanguagesValues: event,
      });
    } else {
    }
  };

  addEduSummary() {
    this.setState({
      EduSummary: [
        ...this.state.EduSummary,
        {
          academics: "",
          qualifications: "",
          academicMessage: "",
          qualificationMessage: "",
          isValidAcademics: true,
          isValidQualifications: true,
        },
      ],
    });
  }

  addAwards() {
    this.setState({
      Awards: [...this.state.Awards, { value: "", message: "", isValid: true }],
    });
  }

  deleteAwards(e, index) {
    console.log(index);
    let tempAwards = this.state.Awards;
    if (tempAwards.length > 1) {
      let newTemp = tempAwards.splice(index, 1);
      console.log(tempAwards);
      this.setState({ Awards: tempAwards });
    }
  }

  deleteEduSummary(e, index) {
    console.log(index);
    let tempEduSummary = this.state.EduSummary;
    if (tempEduSummary.length > 1) {
      let newTemp = tempEduSummary.splice(index, 1);
      console.log(tempEduSummary);
      this.setState({ EduSummary: tempEduSummary });
    }
  }

  render() {
    // console.log('this.state.selectedLanguagesValues',this.state.selectedLanguagesValues);

    let profileSummaryPlaceholder = `This section will be displayed in your Specialist Profile.
        * Describe your professional background and expertise here
        * Be sure to mention your clinic history and success
        * Clear, concise and descriptive profiles gain higher chances for appointment bookings`;

    const options = [
      { label: "Thing 1", value: 1 },
      { label: "Thing 2", value: 2 },
    ];
    var image = this.state.imageCopy;
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var yearList = this.state.experienceList
      ? this.state.experienceList.year
      : [];
    var monthList = this.state.experienceList
      ? this.state.experienceList.month
      : [];
    var specializationList = this.state.specializationList
      ? this.state.specializationList
      : [];
    var conditionalProcedureMapping = this.state.conditionalProcedureMappingList
      ? this.state.conditionalProcedureMappingList
      : [];

      finalConditionalProcedureMappingList = [];
    if (conditionalProcedureMapping) {

      this.state.specializationList.map((item, index) => {
        if (item.id == this.state.specialization.value) {
          conditionalProcedureMapping.map((el) => {
            if (item.label.trim() == el._id) {
              finalConditionalProcedureMappingList.push(el.conditionMappping);
            }
          });
        }
      });

    }
    var noCond = false
    if(finalConditionalProcedureMappingList.length == 0){

      if(this.state.noConditionProcedure == false){
        this.setState({noConditionProcedure:true})
        noCond = true
      }
     
    }
    else if(this.state.noConditionProcedure == true){
      this.setState({noConditionProcedure:false})
      noCond = false
    }

    

    var countryCodeList = constant.PHONENOCOUNTRYCODE
      ? constant.PHONENOCOUNTRYCODE
      : [];
    var clinicInfo = this.state.clinicInfo ? this.state.clinicInfo : [];
    // console.log('clinicInfo', clinicInfo);
    var subspecializationList = this.state.subspecializationList;
    //	var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var defaultImagePath =
      user.gender == "Male"
        ? constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_m.png"
        : constant.PRODUCTION_IMAGE_URL +
          constant.UPLOAD_FOLDER +
          constant.COMMON_FOLDER +
          "doctor_f.png";

          
    if (user.image == constant.DEFAULT_USER_IMAGE) {
      var imagePath =
        constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
    } else {
      var imagePath =
        constant.PRODUCTION_IMAGE_URL +
        constant.UPLOAD_FOLDER +
        localStorage.getItem("userId") +
        "/" +
        user.tempImage;
    }

    {
      this.onrenderimage();
    }

    var user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    var condition =
      (user.userName != undefined || user.gender != undefined) &&
      user.availabilityCount > 0 &&
      user.isVerified == "2";

    // let initialOption = [...this.state.languages];
    const { isVerified } = this.props.specialistInfo;
    // const classes = useStylesReddit();

    return (
      <div>
        <Prompt when={this.state.isDirty} message="There are unsaved changes, are you sure you want to exit? Clicking 'OK' will discard all changes" />
        <header className="main-header">
          <Link
            to={condition ? "/specialist/my-appointment" : null}
            className="logo"
          >
            {" "}
            <span className="logo-mini">
              <img src={require("../../images/img/logo_er_ms.png")} alt="" />
            </span>
            <span className="logo-lg">
              <img src={require("../../images/img/logo_er.png")} alt="" />
            </span>{" "}
          </Link>
          <nav className="navbar navbar-static-top" role="navigation">
            <Link
              to="#"
              className="sidebar-toggle"
              data-toggle="push-menu"
              role="button"
              onClick={this.toggle}
            >
              {" "}
              <img
                src={require("../../images/img/menu_list.svg")}
                alt=""
              />{" "}
              <span className="sr-only">Toggle navigation</span>{" "}
            </Link>
            <div className="navbar-custom-menu">
              <ul className="nav navbar-nav">
                <li
                  onClick={this.onLogoutclick}
                  className={
                    this.state.logoutButton == true
                      ? "dropdown user user-menu show"
                      : "dropdown user user-menu"
                  }
                >
                  <Link
                    to="#"
                    className="dropdown-toggle"
                    data-toggle="dropdown"
                  >
                    <img
                      src={this.state.defaultImageURL}
                      onError={(e) => {
                        e.target.src = defaultImagePath;
                      }}
                      className="user-image"
                      alt="User Image"
                    />
                    <span className="hidden-xs name-capitalize">
                      {user.firstName ? user.firstName : ""}{" "}
                      {user.lastName ? user.lastName : ""}
                    </span>{" "}
                  </Link>
                  <ul
                    className={
                      this.state.logoutButton === true
                        ? "dropdown-menu popupdropdown show"
                        : "dropdown-menu popupdropdown"
                    }
                  >
                    <li className="user-setting">
                      {" "}
                      <Link
                        to={{ pathname: "/specialist/my-settings", state: 1 }}
                      >
                        <img
                          src={require("../../images/Slicing/Settings-profile.png")}
                          className="user-image"
                          alt="User Image"
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span>Settings</span>
                      </Link>
                    </li>
                    <li
                      className="user-footer passwordLink"
                      // style={{ textAlign: "center" }}
                    >
                      <a className="uploadLink" onClick={this._logout}>
                        <img
                          src={require("../../images/Slicing/logout-profile.png")}
                          className="user-image"
                          alt="User Image"
                          onError={(e) => {
                            e.target.src = defaultImagePath;
                          }}
                        />
                        <span> Sign out</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>

        <div className="content-wrapper sp-profile">
          <section className="content container-fluid">
            <ToastContainer position="bottom-left" rtl={true} />
            <div className="row">
              <div className="col-md-12">
                <div className="boxMrgB proCalendar">
                  <div className="nav-tabs-custom">
                    <div className="profile-info-page-header">
                      <Card>
                        <CardContent>
                          <div className="profile-info-page-header-body">
                            <div className="left-header-section">
                              <div className="page-header-name">Profile</div>
                              <div>
                                {" "}
                                <button
                                  className="btn btn-square btn-w-90"
                                  onClick={this.saveSpecialistProfile}
                                >
                                  <span
                                    className="btn-text"
                                    style={{ fontSize: 16 }}
                                  >
                                    Save
                                  </span>
                                </button>
                              </div>
                            </div>
                            <div className="right-header-section">
                              {user.isVerified == 2 ? (
                                <div className="verified-icon">
                                  <img
                                    src={require("../../images/verified.png")}
                                  />
                                </div>
                              ) : (
                                ""
                              )}

                              <div
                                style={{
                                  marginTop: "auto !important",
                                  display: "flex",
                                  alignSelf: "flex-end",
                                }}
                              >
                                <a
                                  style={{ cursor: "pointer" }}
                                  target="_blank"
                                  href="https://test.medfixhealth.com/specialist-requirements"
                                >
                                  <button
                                    className="btn btn-round btn-w-90"
                                    style={{ height: "40px !important" }}
                                  >
                                    <span
                                      className="btn-text"
                                      style={{ fontSize: 16 }}
                                    >
                                      Help
                                    </span>
                                  </button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>

                      {this.state.totalErrors && (
                        <div
                          className="warning-text"
                          style={{ marginBottom: 20, marginTop: 20 }}
                        >
                          <p style={{ fontSize: 16 }}>
                            <ErrorIcon
                              color="rgba(197, 91, 75, 1)"
                              style={{ fontSize: 16, marginRight: 5 }}
                            />
                            Please fix the errors below!
                          </p>
                        </div>
                      )}

                

                      {this.state.isDirty && (
                          <div
                          className="warning-text"
                          style={{ marginBottom: 20, marginTop: 20 }}
                        >
                          <p style={{ fontSize: 16 }}>
                            <ErrorIcon
                              color="rgba(197, 91, 75, 1)"
                              style={{ fontSize: 16, marginRight: 5 }}
                            />
                            Please save your changes!
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <Dialog
                            className="propic-upload-dialog"
                            onClose={this.handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.viewProPicUploadDialog}
                          >
                            <DialogContent dividers>
                              <div className="propic-upload-dialog-content">
                                <div>
                                  <Avatar
                                    src={
                                      this.state.tempUploadedImage !== "" &&
                                      this.state.tempUploadedImage !== null &&
                                      this.state.tempUploadedImage !== undefined
                                        ? this.state.tempUploadedImage
                                        : this.state.tempImageObj !== undefined &&
                                        this.state.tempImageObj !== null &&
                                        this.state.tempImageObj !== ""
                                        ? this.state.tempImageObj
                                        :this.state.imagePreviewUrl === "deleted"?
                                        <CameraAltOutlined/>
                                        : this.state.imageCopy !==
                                            "noUserImage.jpg" &&
                                          this.state.defaultImageURL
                                        ? this.state.defaultImageURL
                                        : defaultImagePath
                                    }
                                    className="propic-icon"
                                    variant="square"
                                  ></Avatar>
                                </div>
                                <div>
                                  <button className="btn btn-square propic-upload-btn btn-w-120">
                                    <input
                                      name="image"
                                      onChange={this.uploadSpecialistImage}
                                      onClick={(event) => {
                                        event.target.value = null;
                                      }}
                                      type="file"
                                      style={{ display: "none" }}
                                      id="avatSelect"
                                    />
                                    <label
                                      className="editimg"
                                      htmlFor="avatSelect"
                                      style={{ cursor: "pointer",height:'100%',width:'100%',padding: '6px 12px',margin:'0px !important' }}
                                    >
                                      <span
                                        className="btn-text"
                                        style={{
                                          fontFamily: "roboto",
                                          fontSize: 13,
                                        }}
                                      >
                                        CHOOSE FILE
                                      </span>
                                      <span className=" editicon tooltip-custom fadeEffect"></span>
                                    </label>
                                  </button>
                                </div>
                                <div>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      fontFamily: "Roboto",
                                    }}
                                  >
                                    A square image that will be shown on your
                                    client portal and widgets. You can upload a
                                    JPG, GIF or PNG file (file size limit is 4
                                    MB, not smaller than 130x130)
                                  </p>
                                </div>
                              </div>
                            </DialogContent>
                            <DialogActions
                              style={{ justifyContent: "flex-end" }}
                            >
                              {this.state.tempUploadedImage || this.state.tempImageObj ||
                              this.state.imageCopy !== "noUserImage.jpg" && this.state.imagePreviewUrl !=="deleted"  ? (
                                <div onClick={this.deleteImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      REMOVE IMAGE
                                    </span>
                                  </button>
                                </div>
                              ) : null}

                              {this.state.tempImageObj ? (
                                <div onClick={this.uploadTempImage}>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    // onClick={this.handleClose}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                      
                                    >
                                      UPLOAD
                                    </span>
                                  </button>{" "}
                                </div>
                              ) : null}

                              <div onClick={this.handleClose}>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>
                            </DialogActions>
                          </Dialog>

                          <Dialog
                            // className="propic-upload-dialog"
                            onClose={this.handleClose2}
                            aria-labelledby="customized-dialog-title"
                            className="removePropicDialog"
                            open={this.state.removeProfileImageDialog}
                          >
                            <DialogContent
                              style={{
                                height: "200px !important",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Image
                                  </p>
                                </div>
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Click on OK to remove the image
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose2}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>

                              {this.state.tempUploadedImage || this.state.tempImageObj||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.deleteImage}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                          </Dialog>

                          <Row>
                            <Col lg={12}></Col>
                          </Row>

                          <form noValidate autoComplete="off">
                            <Row className="personal-info">
                              <Col lg={5}>
                                <div
                                  className="profile-personal-info"
                                  id="personal-information"
                                >
                                  <Card>
                                    <CardContent>
                                      <Typography gutterBottom>
                                        Personal Information{" "}
                                        <Popover
                                          placement="rightBottom"
                                          content={"Edit Personal Information"}
                                          trigger="hover"
                                          className="profile-edit-icon p-info"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                      </Typography>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            type="text"
                                            required
                                            fullWidth
                                            label="Full Name"
                                            inputProps={{ maxLength: 100 }}
                                            // InputProps={{ classes, disableUnderline: true }}
                                            name="userName"
                                            disabled={this.state.isDisablePI}
                                            value={
                                              this.state.userName
                                                ? this.state.userName.value
                                                : ""
                                            }
                                            onChange={this.onChange}
                                          /></ThemeProvider>
                                          <span
                                            className="help-block"
                                            style={{ errorFontSize }}
                                          >
                                            {this.state.userName &&
                                              this.state.userName.message}
                                          </span>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            disabled={this.state.isDisablePI}
                                            name="gender"
                                            label="Gender"
                                            onChange={this.onChange}
                                            value={
                                              (this.state.gender && this.state.gender.value)
                                                ? this.state.gender.value
                                                : ""
                                            }
                                          >
                                            {genderList &&
                                              genderList.map((option) => (
                                                <MenuItem
                                                  key={option.value}
                                                  value={option.value}
                                                >
                                                  {option.label}
                                                </MenuItem>
                                              ))}
                                          </TextField></ThemeProvider>
                                        </Col>
                                      </Row>

                                      <Row className="field-row">
                                        <Col lg={12}>
                                          
                                          <MultipleSelect
                                            label="Languages Spoken *"
                                            values={
                                              this.state.selectedLanguagesValues &&
                                              this.state.selectedLanguagesValues || ""
                                            }
                                            options={languageOptions}
                                            onChange={this.onChangeLanguage}
                                            disabled={this.state.isDisablePI}
                                            variant="standard"
                                            SelectProps={{
                                              isCreatable: true,
                                              msgNoOptionsAvailable:
                                                "All Languages are selected",
                                              msgNoOptionsMatchFilter:
                                                "No language matches the filter",
                                            }}
                                          />
                                          {this.state.languageError.error &&
                                          this.state.languageError.message ? (
                                            <span className="help-block">
                                              {this.state.languageError.message}
                                            </span>
                                          ) : (
                                            <span className="hint">
                                              Select a maximum of 3 languages
                                            </span>
                                          )}
                                        </Col>
                                      </Row>

                                      {this.state.isDisablePI ? (
                                        ""
                                      ) : (
                                        <div className="warning-text">
                                          <p>
                                            Making changes to this section will
                                            resubmit your profile to verify any
                                            updated details. You'll still be
                                            able to continue using the platform.
                                            New changes won't appear on profile
                                            listings until the verification
                                            process completes(up to 3 weeks)
                                          </p>
                                        </div>
                                      )}
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                              <Col lg={4}>
                                <div
                                  className="profile-picture"
                                  id="profile-pic"
                                >
                                  <Card>
                                    <CardContent>
                                      <Typography gutterBottom>
                                        Profile Picture
                                      </Typography>

                                      <p
                                        style={{
                                          fontSize: "12px",
                                          fontFamily: "roboto",
                                          fontWeight: 400,
                                        }}
                                      >
                                        Choose a profile picture you'd like your
                                        patients to view when they go online to
                                        book an appointment
                                      </p>
                                      

                                      <div className="profile-img-bg">
                                       
                                        <Avatar onClick={this.handleClickOpen}>
                                          {this.state.tempUploadedImage !==
                                            "" &&
                                          this.state.tempUploadedImage !==
                                            null &&
                                          this.state.tempUploadedImage !==
                                            undefined ? (
                                            <img
                                              src={this.state.tempUploadedImage}
                                            />
                                          ) : this.state.imagePreviewUrl ===
                                            "deleted" ? (
                                            <CameraAltOutlined />
                                          ) : this.state.imageCopy !==
                                              "noUserImage.jpg" &&
                                            this.state.defaultImageURL ? (
                                            <img
                                              src={this.state.defaultImageURL}
                                            />
                                          ) : (
                                            <CameraAltOutlined />
                                          )}
                                        </Avatar>
                                      </div>
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                              <Col lg={3}>
                                <div className="profile-quick-links">
                                  <Card className="quickLinks">
                                    <CardHeader title="QUICK LINKS" />
                                    <CardContent>
                                      <ul>
                                        <li>
                                          <a href="#personal-information">
                                            Personal Information
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#profile-pic">
                                            Profile Picture
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#educational-summary">
                                            Educational Summary
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#professional-background">
                                            Professional Background
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#achievements-memberships">
                                            Achievements and Memberships
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#profile-summary">
                                            Profile Summary{" "}
                                          </a>
                                        </li>
                                        <li>
                                          <a href="#clinics-schedules">
                                            Clinics and Schedules
                                          </a>
                                        </li>
                                      </ul>
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={9}>
                                <div
                                  className="profile-educational-summary"
                                  id="educational-summary"
                                >
                                  <Card>
                                    <CardContent className="edu-content">
                                      <Typography gutterBottom>
                                        Educational Summary{" "}
                                        <Popover
                                          placement="rightBottom"
                                          content={"Edit Educational Summary"}
                                          trigger="hover"
                                          className="profile-edit-icon edu-info"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                        {/* <img className="profile-edit-icon" src={require('../../images/profile-add-icon.png')} alt="" /> */}
                                        {!this.state.isDisableES && (
                                          <Popover
                                            placement="rightBottom"
                                            content={
                                              "Add credentials and institution"
                                            }
                                            trigger="hover"
                                            className="add-edu"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={this.addEduSummary.bind(
                                              this
                                            )}
                                          >
                                            <AddCircleOutlineIcon
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                color: "#00b5e8",
                                              }}
                                            />
                                          </Popover>
                                        )}
                                      </Typography>
                                      {this.state.EduSummary &&
                                        this.state.EduSummary.map(
                                          (edu, index) => (
                                            <Row key={index}>
                                              <Col lg={5}>
                                              <ThemeProvider theme={theme}>
                                                <TextField 
                                                  type="text"
                                                  required
                                                  fullWidth
                                                  label="Credentials"
                                                  disabled={
                                                    this.state.isDisableES
                                                  }
                                                  name="qualifications"
                                                  onChange={(e) =>
                                                    this.onChange(e, index)
                                                  }
                                                  placeholder="Qualification"
                                                  value={edu.qualifications}
                                                  helperText={
                                                    edu.qualificationsMessage ? (
                                                      <span
                                                        className="help-block"
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "#c55b4b",
                                                        }}
                                                      >
                                                        {
                                                          edu.qualificationsMessage
                                                        }
                                                      </span>
                                                    ) : (
                                                      "Enter professional degrees, diplomas or certifications etc."
                                                    )
                                                  }
                                                /></ThemeProvider>
                                              </Col>
                                              <Col lg={{ span: 5, offset: 1 }} style={{display:'flex',alignItems:'center'}}>
                                              <ThemeProvider theme={theme}>
                                                <TextField
                                                  type="text"
                                                  required
                                                  fullWidth
                                                  label="Educational Institution"
                                                  disabled={
                                                    this.state.isDisableES
                                                  }
                                                  name="academics"
                                                  value={edu.academics}
                                                  id="academics"
                                                  onChange={(e) =>
                                                    this.onChange(e, index)
                                                  }
                                                  placeholder="Academics"
                                                  helperText={
                                                    edu.academicsMessage ? (
                                                      <span
                                                        className="help-block"
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "#c55b4b",
                                                        }}
                                                      >
                                                        {edu.academicsMessage}
                                                      </span>
                                                    ) : (
                                                      "Enter educational institution where degree was awarded."
                                                    )
                                                  }
                                                />
                                                </ThemeProvider>

                                                {!this.state.isDisableES &&
                                                this.state.EduSummary &&
                                                this.state.EduSummary.length >
                                                  1 && (
                                                  <Popover
                                                    placement="rightBottom"
                                                    content={"Delete Row"}
                                                    trigger="hover"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={(e) =>
                                                      this.deleteEduSummary(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      className="deleteEduSummary"
                                                      src={require("../../images/profile-del-icon.png")}
                                                      alt=""
                                                      width="25px"
                                                    />
                                                  </Popover>
                                                )}
                                              </Col>

                                        
                                            </Row>
                                          )
                                        )}
                                      {!this.state.isDisableES && (
                                        <div className="warning-text">
                                          <p>
                                            Making changes to this section will
                                            resubmit your profile to verify any
                                            updated details. You'll still be
                                            able to continue using the platform.
                                            New changes won't appear on profile
                                            listings until the verification
                                            process completes(up to 3 weeks)
                                          </p>
                                        </div>
                                      )}
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={9}>
                                <div
                                  className="profile-professional-background"
                                  id="professional-background"
                                >
                                  <Card>
                                    <CardContent>
                                      <Typography gutterBottom>
                                        Professional Background{" "}
                                        <Popover
                                          placement="rightBottom"
                                          content={
                                            "Edit Professional Background"
                                          }
                                          trigger="hover"
                                          className="profile-edit-icon p-back"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                      </Typography>
                                      <Row>
                                        <Col lg={5}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            type="text"
                                            required
                                            fullWidth
                                            label="Medical Board Registration or License no."
                                            disabled={this.state.isDisablePB}
                                            name="registrationNo"
                                            onChange={this.onChange}
                                            placeholder="Registration No."
                                            value={
                                              this.state.registrationNo.value
                                            }
                                          /></ThemeProvider>
                                    

                                          {this.state.registrationNo.message ?  <span
                                            className="help-block"
                                            style={{ errorFontSize,fontFamily:'roboto',fontSize:12,fontWeight:400 }}
                                          >
                                              {this.state.registrationNo.message}
                                          </span>:
                                          <span className="hint">
                                            Enter Medical License Number
                                            </span>}



                                        </Col>
                                        <Col lg={{ span: 5, offset: 1 }}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            name="specialization"
                                            disabled={this.state.isDisablePB}
                                            label="Specialization"
                                            onChange={this.onSpecializationChange.bind(
                                              this
                                            )}
                                            value={
                                              (this.state.specialization &&
                                              specializationList &&
                                              specializationList.length >0)?
                                              this.state.specialization.value:""
                                            }
                                          >
                                            
                                            {(specializationList &&
                                              specializationList.length > 0) 
                                              ? specializationList.map(
                                                  (option, index) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={option.id}
                                                    >
                                                      {option.label}
                                                    </MenuItem>
                                                  )
                                                )
                                              : ""}
                                          </TextField></ThemeProvider>
                                          {this.state.specialization.message ?  <span
                                            className="help-block"
                                            style={{ errorFontSize,fontFamily:'roboto',fontSize:12,fontWeight:400 }}
                                          >
                                              {this.state.specialization.message}
                                          </span>:
                                          <span className="hint">
                                            Choose your medical specialty
                                            </span>}
                                        </Col>
                                      </Row>
                                      <Row className="p-t-25"></Row>

                                      <Row>
                                        <Col lg={5}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            type="text"
                                            required
                                            fullWidth
                                            label="Subspecialty"
                                            disabled={this.state.isDisablePB}
                                            name="subspecialization"
                                            onChange={this.onSpecializationChange.bind(
                                              this
                                            )}
                                            placeholder="Sub Specialities"
                                            id="subSpecialization"
                                            value={
                                              this.state.subSpecialization.value
                                            }
                                            // helperText="Enter subspecialties separated by commas."
                                          ></TextField></ThemeProvider>
                                          {/* <span
                                            className={
                                              this.state.subSpecialization.value
                                                .length > 300 ||
                                              this.state.subSpecialization
                                                .value == "" ||
                                              this.state.subSpecialization
                                                .message ==
                                                "Only alphabets & comma are allowed in Sub Speciality."
                                                ? " help-block"
                                                : ""
                                            }
                                            style={{
                                              errorFontSize,
                                              color: "#bc75a1",
                                            }}
                                          >
                                            {this.state.subSpecialization &&
                                              this.state.subSpecialization
                                                .message}{" "}
                                          </span> */}



                                          {this.state.subSpecialization.message ?  <span
                                            className="help-block"
                                            style={{ errorFontSize,fontFamily:'roboto',fontSize:12,fontWeight:400 }}
                                          >
                                              {this.state.subSpecialization.message}
                                          </span>:
                                          <span className="hint">
                                            Enter subspecialties separated by commas.
                                            </span>}




                                        </Col>

                                        <Col lg={{ span: 5, offset: 1 }}>
                                          <MultipleSelect
                                            multiple
                                            id="multiple-limit-tags"
                                            options={
                                              finalConditionalProcedureMappingList &&
                                              finalConditionalProcedureMappingList[0]
                                                ? finalConditionalProcedureMappingList[0]
                                                : []
                                            }
                                            // getOptionLabel={(option) =>
                                            //   option.label
                                            // }
                                            onChange={
                                              this.onChangeConditionProcedure
                                            }
                                            values={
                                              this.state.conditionProcedure &&
                                              this.state.conditionProcedure.length > 0 &&
                                              this.state.conditionProcedure.map(
                                                (cond, index) => {
                                                  return cond.value;
                                                }
                                              ) || ""
                                            }
                                            disabled={this.state.isDisablePB || this.state.noConditionProcedure}
                                            variant="standard"
                                            label="Conditions or Procedures"
                                            placeholder="Select conditions and procedures"
                                            // helperText="Select conditions you treat and procedures you perform."
                                            
                                            SelectProps={{
                                              isCreatable: true,
                                              msgNoOptionsAvailable:
                                                "All Conditions and Procedures are selected.",
                                              msgNoOptionsMatchFilter:
                                                "No Conditions and Procedures matches the filter.",
                                            }}
                                          />

                                          {this.state.conditionProcedureMsg ? <span
                                            className="help-block"
                                            style={{ errorFontSize,fontFamily:'roboto',fontSize:12,fontWeight:400 }}
                                          >
                                              {this.state.conditionProcedureMsg}
                                          </span>:
                                         
                                            <span className="hint">
                                              {this.state.noConditionProcedure || this.state.noConditionProcedure? 
                                            "N/A":  "Select conditions you treat and procedures you perform."
                                            }
                                            
                                            </span>}

                                        </Col>
                                      </Row>
                                      <Row className="p-t-25"></Row>

                                      <Row>
                                        <Col lg={3}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            name="yearExperience"
                                            label="Years of Experience"
                                            helperText="Years of experience in your specialty field."
                                            placeholder="Years"
                                            fullWidth
                                            onChange={this.onChange.bind(this)}
                                            disabled={this.state.isDisablePB}
                                            value={
                                              (this.state.yearExperience &&
                                                yearList &&
                                                yearList.length >0 )
                                                ? this.state.yearExperience.value
                                                : ""
                                            }
                                          >
                                            {(yearList && yearList.length) > 0
                                              ? yearList.map(
                                                  (option, index) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </MenuItem>
                                                  )
                                                )
                                              : ""}
                                          </TextField></ThemeProvider>
                                        </Col>

                                        <Col lg={2}>
                                        <ThemeProvider theme={theme}>
                                          <TextField
                                            required
                                            select
                                            fullWidth
                                            className="month-experience"
                                            placeholder="Months"
                                            label=""
                                            disabled={this.state.isDisablePB}
                                            name="monthExperience"
                                            onChange={this.onChange.bind(this)}
                                            value={
                                              (this.state.monthExperience &&
                                              monthList &&
                                              monthList.length > 0)
                                                ? this.state.monthExperience.value
                                                : ""
                                            }
                                          >
                                            {(monthList && monthList.length > 0) 
                                              ? monthList.map(
                                                  (option, index) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </MenuItem>
                                                  )
                                                )
                                              : ""}
                                          </TextField></ThemeProvider>
                                        </Col>

                                        <Col lg={{ span: 5, offset: 1 }}>
                                          {this.state.isDisablePB ? (
                                            ""
                                          ) : (
                                            <div className="warning-text">
                                              <p>
                                                Making changes to this section
                                                will resubmit your profile to
                                                verify any updated details.
                                                You'll still be able to continue
                                                using the platform. New changes
                                                won't appear on profile listings
                                                until the verification process
                                                completes(up to 3 weeks)
                                              </p>
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={9}>
                                <div
                                  className="profile-achievements-memberships"
                                  id="achievements-memberships"
                                >
                                  <Card
                                    style={{ paddingLeft: "0px!important" }}
                                  >
                                    <CardContent>
                                      <Typography gutterBottom>
                                        Achievements and Memberships
                                        <Popover
                                          placement="rightBottom"
                                          content={
                                            "Edit Achievements and Membership"
                                          }
                                          trigger="hover"
                                          className="profile-edit-icon awards"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                        {!this.state.isDisableAM && (
                                          <Popover
                                            placement="rightBottom"
                                            content={
                                              "Add Achievements and Membership"
                                            }
                                            trigger="hover"
                                            onClick={this.addAwards.bind(this)}
                                          >
                                            <AddCircleOutlineIcon
                                              style={{
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                color: "#00b5e8",
                                              }}
                                            />
                                          </Popover>
                                        )}
                                      </Typography>
                                      {this.state.Awards &&
                                        this.state.Awards.map(
                                          (award, index) => (
                                            <Row
                                              key={index}
                                              style={{
                                                alignItems: "center",
                                                marginBottom: 20,
                                              }}
                                            >
                                              <Col
                                                lg={11}
                                                style={{ marginBottom: 20,maxWidth: '100%',display:'flex',alignItems:'center',flexWrap:"nowrap !important",flexFlow: "nowrap !important" }}
                                              >
                                                <ThemeProvider theme={theme}>
                                                <TextField
                                                  type="text"
                                                  required
                                                  fullWidth
                                                  label="Awards"
                                                  disabled={
                                                    this.state.isDisableAM
                                                  }
                                                  name="professionalAward"
                                                  id="professionalAward"
                                                  onChange={(e) =>
                                                    this.onChange(e, index)
                                                  }
                                                  placeholder="Professional Awards / Memberships of Professional Associations."
                                                  value={award.value}
                                                  helperText={
                                                    award.message ? (
                                                      <span
                                                        className="help-block"
                                                        style={{
                                                          fontSize: "12px",
                                                          color: "#c55b4b",
                                                        }}
                                                      >
                                                        {award.message}{" "}
                                                      </span>
                                                    ) : (
                                                      "Example: Professional Associations, Awards, Recognitions etc."
                                                    )
                                                  }
                                                /></ThemeProvider>

                                                {!this.state.isDisableAM &&
                                                this.state.Awards &&
                                                this.state.Awards.length >
                                                  1 && (
                                                  <Popover
                                                    placement="rightBottom"
                                                    content={"Delete Row"}
                                                    trigger="hover"
                                                    onClick={(e) =>
                                                      this.deleteAwards(
                                                        e,
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      className="deleteAwards"
                                                      src={require("../../images/profile-del-icon.png")}
                                                      alt=""
                                                      width="25px"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </Popover>
                                                )}
                                              </Col>

                                              
                                            </Row>
                                          )
                                        )}
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={9}>
                                <div
                                  className="profile-summary"
                                  id="profile-summary"
                                >
                                  <Card>
                                    <CardContent>
                                      <Typography
                                        gutterBottom
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        Profile Summary
                                        <Popover
                                          placement="rightBottom"
                                          content={"Edit Profile Summary"}
                                          trigger="hover"
                                          className="profile-edit-icon p-sum"
                                          onClick={this.enableEditMode.bind(
                                            this
                                          )}
                                        >
                                          <img
                                            src={require("../../images/profile-edit-icon.png")}
                                            alt=""
                                          />
                                        </Popover>
                                      </Typography>
                                      <Row style={{ padding: "0px 0px" }}>
                                        <Col
                                          lg={12}
                                          style={{
                                            paddingLeft: "0px !important",
                                          }}
                                        >
                                          <TextField
                                            value={
                                              this.state.profileSummary.value
                                            }
                                            style={{ marginBottom: 20 }}
                                            required
                                            name="profileSummary"
                                            label="Profile Summary"
                                            onChange={this.onChange}
                                            disabled={this.state.isDisablePS}
                                            placeholder={profileSummaryPlaceholder}
                                            multiline
                                            fullWidth
                                            rows={4}
                                            helperText="Example: A short description about your profile and your expertise."
                                            rowsMax={4}
                                          />
                                        </Col>
                                      </Row>
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={9}>
                                <div
                                  className="profile-clinics-schedules"
                                  id="clinics-schedules"
                                >
                                  <Card>
                                    <CardContent>
                                      <Typography
                                        gutterBottom
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        Clinics and Schedules
                                        {/* <img onClick={this.openModal} className="profile-edit-icon" src={require('../../images/profile-add-icon.png')} alt="" /> */}
                                        <Popover
                                          placement="rightBottom"
                                          content={"Create Clinic"}
                                          trigger="hover"
                                          onClick={this.openModal}
                                        >
                                          <AddCircleOutlineIcon
                                            style={{
                                              cursor: "pointer",
                                              marginLeft: "10px",
                                              color: "#00b5e8",
                                            }}
                                          />
                                        </Popover>
                                      </Typography>

                                      {/* <div className="row mt"> */}
                                      <div
                                        className="box-body table-responsive attachmentTable"
                                        style={{ paddingLeft: "0px" }}
                                      >
                                        <div className="table-responsive clinics-table-border">
                                          {(clinicInfo && clinicInfo.length) >
                                          0 ? (
                                            <table className="table table-hover">
                                              <tbody>
                                                <tr>
                                                  <th>Clinic Name </th>
                                                  <th>Clinic Address</th>
                                                  <th>Clinic Type</th>
                                                  <th>Consultation Fees</th>
                                                  <th>Schedule</th>
                                                  <th>Action</th>
                                                </tr>
                                                {clinicInfo &&
                                                clinicInfo.length > 0
                                                  ? clinicInfo.map(
                                                      (option, index) => (
                                                        <tr key={index}>
                                                          <td className="text-capitalize">
                                                            <a
                                                              onClick={this.showClinicViewModal.bind(
                                                                this,
                                                                option
                                                              )}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            >
                                                              {
                                                                option.clinicName
                                                              }
                                                            </a>
                                                          </td>
                                                          <td className="capitalize">
                                                            {option.addressLineOne +
                                                              ", " +
                                                              option.city +
                                                              ", " +
                                                              option.state +
                                                              ", " +
                                                              option.country +
                                                              ", " +
                                                              option.zipCode}
                                                          </td>
                                                          <td>{option.isPrimaryAddress == true ? 'Primary' : 'Other'}</td>
                                                          <td>
                                                            {option.currencySymbol +
                                                              " " +
                                                              option.fee}
                                                          </td>
                                                          <td>{`${
                                                            option.saturday ==
                                                            true
                                                              ? "Sat"
                                                              : ""
                                                          }   ${
                                                            option.sunday ==
                                                            true
                                                              ? "Sun"
                                                              : ""
                                                          }   ${
                                                            option.monday ==
                                                            true
                                                              ? "Mon"
                                                              : ""
                                                          }  ${
                                                            option.tuesday ==
                                                            true
                                                              ? "Tue"
                                                              : ""
                                                          }  ${
                                                            option.wednesday ==
                                                            true
                                                              ? "Wed"
                                                              : ""
                                                          }  ${
                                                            option.thursday ==
                                                            true
                                                              ? "Thu"
                                                              : ""
                                                          }  ${
                                                            option.friday ==
                                                            true
                                                              ? "Fri"
                                                              : ""
                                                          } `}</td>
                                                          
                                                          <td
                                                            style={{
                                                              whiteSpace:
                                                                "nowrap",
                                                              display: "flex",
                                                              alignItems:
                                                                "flex-start",
                                                            }}
                                                          >
                                                            <Link
                                                              to="#"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginRight: 10,
                                                                height: "20px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                              onClick={this.editAvailability.bind(
                                                                this,
                                                                index
                                                              )}
                                                              className="deleteLink"
                                                            >
                                                              <img
                                                                src={require("../../images/profile-edit-icon.png")}
                                                                alt=""
                                                                width="20px"
                                                                height="20px"
                                                                style={{
                                                                  margin:
                                                                    "auto",
                                                                }}
                                                              />
                                                            </Link>
                                                            <Link
                                                              to="#"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                height: "20px",
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                              onClick={this.deleteAvailabilityDialog.bind(
                                                                this,
                                                                option._id,
                                                                option.isPrimaryAddress
                                                              )}
                                                              className="deleteLink"
                                                            >
                                                              <img
                                                                src={require("../../images/profile-del-icon.png")}
                                                                alt=""
                                                                width="20px"
                                                              />
                                                            </Link>
                                                          </td>
                                                        </tr>
                                                      )
                                                    )
                                                  : ""}
                                              </tbody>
                                            </table>
                                          ) : (
                                            ""
                                          )}
                                        </div>{" "}



                                            


                                      </div>

                                      {this.state.consultationErrMsg && (
                          <div
                          className="warning-text"
                          style={{ marginBottom: 0, marginTop: 20 }}
                        >
                          <p style={{ fontSize: 16 }}>
                            <ErrorIcon
                              color="rgba(197, 91, 75, 1)"
                              style={{ fontSize: 16, marginRight: 5 }}
                            />
                            {this.state.consultationErrMsg}
                          </p>
                        </div>
                      )
                      
                      }
                                      {/* </div> */}
                                    </CardContent>
                                  </Card>
                                </div>
                              </Col>
                            </Row>
                          </form>

                          {/* <SpecialistLanguage
                            isOpen={this.state.openLanguageModal}
                            closeLanguageModal={this.closeLanguageModal}
                            onSelect={this.onSelect}
                            onRemove={this.onRemove}
                            initialLanguage={this.state.languages}
                          /> */}

                          <Modal
                            isOpen={this.state.modalIsOpen}
                            onRequestClose={this.closeModal}
                            contentLabel="Availability Modal"
                          >
                            <Availability
                              className="r_Modal"
                              clinicName={this.state.clinicName}
                              addressLineOne={this.state.addressLineOne}
                              sunday={this.state.sunday}
                              saturday={this.state.saturday}
                              monday={this.state.monday}
                              tuesday={this.state.tuesday}
                              wednesday={this.state.wednesday}
                              thursday={this.state.thursday}
                              friday={this.state.friday}
                              sundayMorning={this.state.sundayMorning}
                              sundayEvening={this.state.sundayEvening}
                              mondayMorning={this.state.mondayMorning}
                              mondayEvening={this.state.mondayEvening}
                              tuesdayMorning={this.state.tuesdayMorning}
                              tuesdayEvening={this.state.tuesdayEvening}
                              wednesdayMorning={this.state.wednesdayMorning}
                              wednesdayEvening={this.state.wednesdayEvening}
                              thursdayMorning={this.state.thursdayMorning}
                              thursdayEvening={this.state.thursdayEvening}
                              fridayMorning={this.state.fridayMorning}
                              fridayEvening={this.state.fridayEvening}
                              saturdayEvening={this.state.saturdayEvening}
                              saturdayMorning={this.state.saturdayMorning}
                              changeInAvailability={this.changeInAvailability.bind(
                                this
                                )}
                                timezoner={this.state.timezoner}
                                Address={this.state.Address}
                                updateAddress={this.updateAddress.bind(this)}
                                onChange={this.onChange.bind(this)}
                                isDisabled={this.state.isDisabled}
                                timezones={this.timezones.bind(this)}
                                closeModal={this.closeModal.bind(this)}
                                submitAvailability={this.submitAvailability}
                                countryList={this.state.countryList}
                                // onCountryChange={this.onCountryChange.bind(this)}
                                country={this.state.country}
                                stateList={this.state.stateList}
                                stateName={this.state.stateName}
                                phoneCodeList={this.state.phoneCodeList}
                                phoneCode1={this.state.phoneCode1}
                                phoneCode2={this.state.phoneCode2}
                                currencyList={this.state.currencyList}
                                currencySymbol={this.state.currencySymbol}
                                fee={this.state.fee}
                                city={this.state.city}
                                zipCode={this.state.zipCode}
                                mobileNo={this.state.mobileNo}
                                telephoneNo={this.state.telephoneNo}
                              editIndex={this.state.editIndex}
                              isFromEdit={this.state.isFromEdit}
                              specialization={this.state.specialization}
                              availId={this.state.availId}
                              checkZipCode={this.checkZipCode}
                              isValidZipcode={this.state.isValidZipcode}
                              isPrimary={this.state.isPrimary}
                              changePrimaryLocation={this.changePrimaryLocation.bind(
                                this
                                )}
                                // handleClinicBannerImage={this.handleClinicBannerImage.bind(
                                  //   this
                                  // )}
                                  clinicBannerImage = {this.state.clinicBannerImage}
                                  //Clinic Banner Image Temp for Preview
                                  tempBannerImage = {this.state.tempBannerImage}
                                  tempUpClinicBanner={this.state.tempUpClinicBanner}
                                  removeClinicBanner={this.removeClinicBanner.bind(
                                    this
                              )}
                              UploadClinicBanner ={this.UploadClinicBanner.bind(this)}
                              // clinicBanner={this.state.clinicBanner}
                              handleCloseBannerModal = {this.handleCloseBannerModal.bind(this)}
                              clinicInfo={this.state.clinicInfo}
                              //saturday
                              handleSaturdayMSTimeChange={this.handleSaturdayMSTimeChange.bind(
                                this
                              )}
                              handleSaturdayMETimeChange={this.handleSaturdayMETimeChange.bind(
                                this
                              )}
                              handleSaturdayESTimeChange={this.handleSaturdayESTimeChange.bind(
                                this
                              )}
                              handleSaturdayEETimeChange={this.handleSaturdayEETimeChange.bind(
                                this
                              )}
                              saturdayMornSTValid={
                                this.state.saturdayMornSTValid
                              }
                              saturdayMornETValid={
                                this.state.saturdayMornETValid
                              }
                              saturdayEvenSTValid={
                                this.state.saturdayEvenSTValid
                              }
                              saturdayEvenETValid={
                                this.state.saturdayEvenETValid
                              }
                              saturdayMorningSchedule={
                                this.state.saturdayMorningSchedule
                              }
                              saturdayEveningSchedule={
                                this.state.saturdayEveningSchedule
                              }
                              //sunday
                              handleSundayMSTimeChange={this.handleSundayMSTimeChange.bind(
                                this
                              )}
                              handleSundayMETimeChange={this.handleSundayMETimeChange.bind(
                                this
                              )}
                              handleSundayESTimeChange={this.handleSundayESTimeChange.bind(
                                this
                              )}
                              handleSundayEETimeChange={this.handleSundayEETimeChange.bind(
                                this
                              )}
                              sundayMornSTValid={this.state.sundayMornSTValid}
                              sundayMornETValid={this.state.sundayMornETValid}
                              sundayEvenSTValid={this.state.sundayEvenSTValid}
                              sundayEvenETValid={this.state.sundayEvenETValid}
                              sundayMorningSchedule={
                                this.state.sundayMorningSchedule
                              }
                              sundayEveningSchedule={
                                this.state.sundayEveningSchedule
                              }
                              //monday
                              handleMondayMSTimeChange={this.handleMondayMSTimeChange.bind(
                                this
                              )}
                              handleMondayMETimeChange={this.handleMondayMETimeChange.bind(
                                this
                              )}
                              handleMondayESTimeChange={this.handleMondayESTimeChange.bind(
                                this
                              )}
                              handleMondayEETimeChange={this.handleMondayEETimeChange.bind(
                                this
                              )}
                              mondayMornSTValid={this.state.mondayMornSTValid}
                              mondayMornETValid={this.state.mondayMornETValid}
                              mondayEvenSTValid={this.state.mondayEvenSTValid}
                              mondayEvenETValid={this.state.mondayEvenETValid}
                              mondayMorningSchedule={
                                this.state.mondayMorningSchedule
                              }
                              mondayEveningSchedule={
                                this.state.mondayEveningSchedule
                              }
                              //tuesday
                              handleTuesdayMSTimeChange={this.handleTuesdayMSTimeChange.bind(
                                this
                              )}
                              handleTuesdayMETimeChange={this.handleTuesdayMETimeChange.bind(
                                this
                              )}
                              handleTuesdayESTimeChange={this.handleTuesdayESTimeChange.bind(
                                this
                              )}
                              handleTuesdayEETimeChange={this.handleTuesdayEETimeChange.bind(
                                this
                              )}
                              tuesdayMornSTValid={this.state.tuesdayMornSTValid}
                              tuesdayMornETValid={this.state.tuesdayMornETValid}
                              tuesdayEvenSTValid={this.state.tuesdayEvenSTValid}
                              tuesdayEvenETValid={this.state.tuesdayEvenETValid}
                              tuesdayMorningSchedule={
                                this.state.tuesdayMorningSchedule
                              }
                              tuesdayEveningSchedule={
                                this.state.tuesdayEveningSchedule
                              }
                              //wdnesday
                              handleWednesdayMSTimeChange={this.handleWednesdayMSTimeChange.bind(
                                this
                              )}
                              handleWednesdayMETimeChange={this.handleWednesdayMETimeChange.bind(
                                this
                              )}
                              handleWednesdayESTimeChange={this.handleWednesdayESTimeChange.bind(
                                this
                              )}
                              handleWednesdayEETimeChange={this.handleWednesdayEETimeChange.bind(
                                this
                              )}
                              wednesdayMornSTValid={
                                this.state.wednesdayMornSTValid
                              }
                              wednesdayMornETValid={
                                this.state.wednesdayMornETValid
                              }
                              wednesdayEvenSTValid={
                                this.state.wednesdayEvenSTValid
                              }
                              wednesdayEvenETValid={
                                this.state.wednesdayEvenETValid
                              }
                              wednesdayMorningSchedule={
                                this.state.wednesdayMorningSchedule
                              }
                              wednesdayEveningSchedule={
                                this.state.wednesdayEveningSchedule
                              }
                              //thursday
                              handleThursdayMSTimeChange={this.handleThursdayMSTimeChange.bind(
                                this
                              )}
                              handleThursdayMETimeChange={this.handleThursdayMETimeChange.bind(
                                this
                              )}
                              handleThursdayESTimeChange={this.handleThursdayESTimeChange.bind(
                                this
                              )}
                              handleThursdayEETimeChange={this.handleThursdayEETimeChange.bind(
                                this
                              )}
                              thursdayMornSTValid={
                                this.state.thursdayMornSTValid
                              }
                              thursdayMornETValid={
                                this.state.thursdayMornETValid
                              }
                              thursdayEvenSTValid={
                                this.state.thursdayEvenSTValid
                              }
                              thursdayEvenETValid={
                                this.state.thursdayEvenETValid
                              }
                              thursdayMorningSchedule={
                                this.state.thursdayMorningSchedule
                              }
                              thursdayEveningSchedule={
                                this.state.thursdayEveningSchedule
                              }
                              //thursday
                              handleFridayMSTimeChange={this.handleFridayMSTimeChange.bind(
                                this
                              )}
                              handleFridayMETimeChange={this.handleFridayMETimeChange.bind(
                                this
                              )}
                              handleFridayESTimeChange={this.handleFridayESTimeChange.bind(
                                this
                              )}
                              handleFridayEETimeChange={this.handleFridayEETimeChange.bind(
                                this
                              )}
                              fridayMornSTValid={this.state.fridayMornSTValid}
                              fridayMornETValid={this.state.fridayMornETValid}
                              fridayEvenSTValid={this.state.fridayEvenSTValid}
                              fridayEvenETValid={this.state.fridayEvenETValid}
                              fridayMorningSchedule={
                                this.state.fridayMorningSchedule
                              }
                              fridayEveningSchedule={
                                this.state.fridayEveningSchedule
                              }
                              zipCodeMatch={this.state.zipcodeMatch}
                              showNotificationFlag={
                                this.state.showNotificationDiv
                              }
                              changeInMobileNumber={this.changeInMobileNumber}

                              /* timeListArr={this.state.timeList} */
                            />
                          </Modal>
                        </div>
                      </div>

                      {this.state.viewClinicModal ? (
                        <ClinicDetail
                          show={true}
                          hideClinicModal={this.hideClinicViewModal.bind()}
                          viewClinicInfo={this.state.viewClinicData}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>


                        <Dialog
                        className="clinicDialog"
                        aria-labelledby="customized-dialog-title"
                        open={this.state.deleteClinicDialog}
                        onClose={this.handleClose3}
                        >
                          
                          <DialogContent
                              style={{
                                height: "300px !important",
                                width: "398px",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                                borderRadius:4
                              }}
                            >
                                    <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Clinic
                                  </p>
                                </div>
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                             
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Removing a clinic will also delete address and availability details. Do you wish to proceed?
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose3}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>

                              {this.state.tempUploadedImage ||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.deleteAvailability}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                        </Dialog>

                        <Dialog
                        aria-labelledby="customized-dialog-title"
                        open={this.state.chooseAnotherClinicDialog}
                        onClose={this.handleClose3}
                        className="clinicDialog"
                        >
                          
                          <DialogContent
                              style={{
                                height: "300px !important",
                                width: "398px",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                                borderRadius:4
                              }}
                            >
                                    <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Clinic
                                  </p>
                                </div>
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                             
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Please select another location as your primary clinic before removing the current primary consultation address.
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                            

                              {this.state.tempUploadedImage ||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.handleClose3}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                        </Dialog>












                        <Dialog
                        aria-labelledby="customized-dialog-title"
                        open={this.state.designatePrimaryDialog}
                        onClose={this.handleClose4.bind(this)}
                        className="clinicDialog"
                        >
                          
                          <DialogContent
                              style={{
                                height: "300px !important",
                                width: "398px",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                                borderRadius:4
                              }}
                            >
                                    <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Confirm
                                  </p>
                                </div>
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                             
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Designate this location as your primary clinic address?
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.designatePrimaryNot.bind(this)}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    No
                                  </span>
                                </button>{" "}
                              </div>

                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.designatePrimary.bind(this)}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      Yes
                                    </span>
                                  </button>
                                </div>
                            </DialogActions>
                        </Dialog>















          <div className="Copyrightafterlogin">
            <p>Medfix &copy; 2018. All rights reserved</p>
          </div>
        </div>
      </div>
    );
  }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
  return {
    experienceList: state.specialist.experienceList,
    specializationList: state.specialist.specializationList,
    subSpecializationList: state.specialist.subSpecializationList,
    countryList: state.specialist.countryList,
    stateList: state.specialist.stateList,
    specialistInfo: state.specialist.specialistProfile,
    zipcodeInfo: state.specialist.zipcodeInfo,
    clinicInfo: state.specialist.clinicInfo,
    successMsg: state.specialist.successMsg,
    conditionalProcedureMappingList:
      state.specialist.conditionalProcedureMappingList,
  };
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(specialistActions, dispatch),
    logoutAction: bindActionCreators(dashboardActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
    // saveLanguageToSpecialist: bindActionCreators
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SpecialistProfile);
